import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core'
import { ProcessModality, ProcessBidType } from '@models/planning/process.model'
import {
	SupplierEnrollmentNoticeMessageType,
	SupplierEnrollmentNoticeStatus,
	SupplierEnrollmentNoticeAttachmentType,
	SupplierEnrollmentNotice,
	SupplierEnrollmentNoticeSearch,
	SupplierEnrollmentNoticeCounterargument,
	SupplierEnrollmentNoticeCounterargumentSearch,
	SupplierEnrollmentNoticeCounterargumentType,
	SupplierEnrollmentNoticeCounterargumentStatus,
	SupplierEnrollmentNoticeJudging,
	SupplierEnrollmentNoticeAttachment,
	SupplierEnrollmentNoticeMessage,
	SupplierEnrollmentNoticeUndoStatus
} from '@models/supplier/notice/supplier-enrollment-notice.model'
import { HttpParams } from '@angular/common/http'
import { Observable, firstValueFrom, finalize, expand, EMPTY, map, from, toArray, catchError, of, forkJoin, switchMap, Subject, interval, Subscription } from 'rxjs'
import { Paginate, emptyPaginateObservable } from '@models/paginate.model'
import { SupplierEnrollmentNoticeService } from '@services/supplier-enrollment-notice.service'
import { NoticeSessionStatus, NoticeSession } from '@models/planning/notice-session.model'
import { NoticeSessionPhaseBidSearch, NoticeSessionPhaseBidStatus } from '@models/planning/notice-session-phase-bid.model'
import { NoticeSessionPhaseBidService } from '@services/notice-session-phase-bid.service'
import { ChatRoomService } from '@services/chat-room.service'
import { ChatParticipantRole } from '@models/chat/chat.model'
import { concatMap, tap, takeUntil, exhaustMap } from 'rxjs/operators'
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import {
	DemandIntentDocument,
	DemandIntentDocumentPublishStatus,
	DemandIntentDocumentStatus,
	DemandIntentDocumentProcessItem
} from '@models/demand/demand-intent-document.model'
import { AlertifyService } from '@services/alertify.service'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { DemandIntentDocumentService } from '@services/demand-intent-document.service'
import { ToastService } from '@common/services'
import { SupplierEnrollmentNoticeCounterargumentService } from '@services/supplier-enrollment-notice-counterargument.service'
import { SupplierEnrollmentNoticeMessageService, SupplierEnrollmentNoticeMessageItem } from '@services/supplier-enrollment-notice-message.service'
import { groupSessionTimelineByDate, eventSourceIcon, SessionTimelineGroup } from '@utils/session-timeline.util'
import { NoticeSessionService } from '@services/notice-session.service'
import chunk from 'lodash.chunk'
import { PncpOrganizationService } from '@services/pncp-organization.service'
import { AttachmentService } from '@services/attachment.service'
import { NotificationSocketService } from '@services/socket/notification-socket.service'
import { NotificationType, MessageSourceType } from '@modules/messages/models'
import { DocumentGeneratorType, DocumentGeneratorRequest } from '@models/document-generator/notice/document-generator.model'
import { BaseDocument } from '@models/document-generator/notice/document.model'
import { DocumentGeneratorService } from '@services/document-generator.service'
import { DomSanitizer } from '@angular/platform-browser'
import { UploadStatus, FileUploadAttachment } from '@models/attachment/upload-attachment.model'
import { UploadS3Service } from '@services/upload-s3.service'
import {
	DemandIntentDocumentReport,
	DemandIntentDocumentReportStatus,
	DemandIntentDocumentReportType
} from '@models/demand/demand-intent-document-report.model'
import moment, * as momentTz from 'moment-timezone'
import { DocumentGeneratorProvider } from '@providers/document-generator.provider'
import { NgxMaskPipe } from 'ngx-mask'
import {
	ReportFinalPreQualificationAccreditationDocumentGenerator,
	SessionSupplier,
	SessionEvent
} from '@models/document-generator/report/report-final-pre-qualification-accreditation-document.generator.model'
import { LabelService } from '@services/label.service'
import { AccountService } from '@services/account.service'
import { v4 as uuid } from 'uuid'
import { NoticeSessionRepresentation } from '@models/planning/notice-session-representation.model'
import { NoticeSessionMessage } from '@models/planning/notice-session-message.model'
import { NoticeSessionRepresentationService } from '@services/notice-session-representation.service'
import { DateValidator } from '@validators/date.validator'
import { ReportAnalyticsPreQualificationAccreditationDocumentGenerator } from '@models/document-generator/report/report-analytics-pre-qualification-accreditation-document.generator.model'
import { CertificatedPreQualificationDocumentGenerator } from '@models/document-generator/notice/certificated-pre-qualification-document-generator.model'
import { CertificatedAccreditationDocumentGenerator } from '@models/document-generator/notice/certificated-accreditation-document-generator.model'
import { ChartUtil } from '@utils/chart.util'
import { ContractEstimateRow } from '@models/document-generator/notice/etp-document-generator.model'
import { RESPONSIBILITY_EXPENSE_MANAGER_ID } from '@services/responsible.service'
import { DemandIntentDocumentItemService } from '@services/demand-intent-document-item.service'
import { Supplier } from '@models/supplier/supplier.model'
import { DocumentValidator } from '@validators/document.validator'
import { ZipEntry, ZipService } from '@services/zip.service'
import { normalize } from '@utils/str.util'
import { PROPOSAL_REJECTION_REASONS, ProposalRejectionReason } from '@utils/proposal-rejection-reason.util'
import { DateUtil, OwlDateTimeIntlPtBr } from '@utils/date.util'
import { OwlDateTimeIntl } from '@danielmoncada/angular-datetime-picker'
import {
	ResultProposal,
	SupplierEnrollmentNoticeProposalBidData,
	proposalBidsWithCurrentInitial
} from '@models/supplier/notice/proposal/supplier-enrollment-notice-proposal.model'
import { SupplierEnrollmentNoticeProposalService } from '@services/supplier-enrollment-notice-proposal.service'
import { SupplierEnrollmentNoticeTradingService } from '@services/supplier-enrollment-notice-trading.service'
import {
	SupplierEnrollmentNoticeTradingRequest,
	SupplierEnrollmentNoticeTrading,
	SupplierEnrollmentNoticeTradingStatus
} from '@models/supplier/notice/proposal/supplier-enrollment-notice-trading.model'
import { SupplierEnrollmentNoticeFeasibilityService } from '@services/supplier-enrollment-notice-feasibility.service'
import { SupplierEnrollmentNoticeAdjustedService } from '@services/supplier-enrollment-notice-adjusted.service'
import { SupplierEnrollmentNoticeQualificationService } from '@services/supplier-enrollment-notice-qualification.service'
import {
	SupplierEnrollmentNoticeFeasibility,
	SupplierEnrollmentNoticeFeasibilityRequest,
	SupplierEnrollmentNoticeFeasibilityStatus
} from '@models/supplier/notice/proposal/supplier-enrollment-notice-feasibility.model'
import {
	SupplierEnrollmentNoticeAdjusted,
	SupplierEnrollmentNoticeAdjustedRequest,
	SupplierEnrollmentNoticeAdjustedStatus
} from '@models/supplier/notice/proposal/supplier-enrollment-notice-adjusted.model'

/** `qualification`: solicitações de habilitação por proposta (spec 043), no portal do fornecedor. */
export type ModalProposalType = 'feasibility' | 'adjusted' | 'qualification'

type BatchItemsGroup = {
	batchKey: string
	batchExternalCode: string
	batchDescription: string
	items: DemandIntentDocumentProcessItem[]
}

@Component({
	selector: 'app-session-enrollment',
	templateUrl: './session-enrollment.component.html',
	styleUrl: './session-enrollment.component.scss',
	standalone: false
})
export class SessionEnrollmentComponent implements OnInit, OnDestroy {
	@ViewChild('modalTrading') modalTrading: NgbModalRef
	@ViewChild('modalBidding') modalBidding: NgbModalRef
	@ViewChild('modalMessages') modalMessages: NgbModalRef
	@ViewChild('modalLogAction') modalLogAction: NgbModalRef
	@ViewChild('modalAttachment') modalAttachment: NgbModalRef
	@ViewChild('modalAttachmentView') modalAttachmentView: NgbModalRef
	@ViewChild('modalCounterarguments') modalCounterarguments: NgbModalRef
	@ViewChild('modalPublishLooseOther') modalPublishLooseOther: NgbModalRef
	@ViewChild('modalProposalInapposite') modalProposalInapposite: NgbModalRef
	@ViewChild('modalConfirmCertificate') modalConfirmCertificate: NgbModalRef
	@ViewChild('modalFeasibilityAdjusted') modalFeasibilityAdjusted: NgbModalRef
	@ViewChild('modalRequestRepresentation') modalRequestRepresentation: NgbModalRef
	@ViewChild('modalGratedCounterargument') modalGratedCounterargument: NgbModalRef
	@ViewChild('modalConfirmJudgingSupplier') modalConfirmJudgingSupplier: NgbModalRef
	@ViewChild('modalAttachmentViewSupplier') modalAttachmentViewSupplier: NgbModalRef
	@ViewChild('modalRejectedSupplierPending') modalRejectedSupplierPending: NgbModalRef
	@ViewChild('modalCounterargumentSupplierPending') modalCounterargumentSupplierPending: NgbModalRef
	@ViewChild('modalParticipantEvents') modalParticipantEvents: NgbModalRef

	@Input() demand!: DemandIntentDocument
	/**
	 * Com disputa, Abrir/Fechar/Reabrir ficam no cabeçalho da aba Disputa, à direita das sub-abas, e
	 * valem de qualquer uma delas (28/09/2026) — aqui, dentro da sub-aba Participantes, não se repetem.
	 */
	@Input() sessionActionsHidden = false
	/**
	 * Abrir/Fechar/Reabrir pelas ações daqui (processos sem disputa): o bid-board abre o chat quando a
	 * sessão abre (29/09/2026).
	 */
	@Output() sessionStatusChange = new EventEmitter<NoticeSessionStatus>()

	modalGratedCounterargumentRef: NgbModalRef

	submitted: boolean
	attachmentUrl: any
	loadingTrading: boolean
	attachmentTitle: string
	loadingProposal: boolean
	listableProposal: boolean
	noticeAttachment: boolean
	submittedLocking: boolean
	confirmSubmitted: boolean
	attachmentSidebar: boolean
	submittedProposal: boolean
	attachmentLoading: boolean
	submittedAttachment: boolean
	forceGenerateDocuments: boolean
	errorGenerateAnalytics: boolean
	listableRepresentations: boolean
	submittedRepresentation: boolean
	errorGenerateCertificate: boolean
	submittedAttachmentLoading: boolean
	submittedGenerateAnalytics: boolean
	submittedProposalInapposite: boolean
	/** Recusa da proposta fora da inversão de fases (PC-11): motivo da lista fechada e complemento livre. */
	readonly proposalRejectionReasons = PROPOSAL_REJECTION_REASONS
	inappositeReason: ProposalRejectionReason | null = null
	inappositeDescription = ''
	private inappositeDone: (() => void) | null = null
	submittedProposalAppropriate: boolean
	submittedGenerateCertificate: boolean

	supplierEnrollmentNoticesLoading: boolean
	supplierEnrollmentNotice!: SupplierEnrollmentNotice
	noticeSessionRepresentation!: NoticeSessionRepresentation
	supplierEnrollmentNoticeParams = new HttpParams()

	private destroy$ = new Subject<void>()
	private supplierPublishPooling = new Map<string, SupplierEnrollmentNotice>()
	private supplierPublishPoolingSubscription: Subscription | null = null
	private participantEventsCancel$ = new Subject<void>()
	private currentParticipants: SupplierEnrollmentNotice[] = []
	private readonly agentParticipantUpdateTypes = new Set<string>([
		MessageSourceType.SUPPLIER_ENROLLMENT_NOTICE_TRADING_ANSWERED,
		MessageSourceType.SUPPLIER_ENROLLMENT_NOTICE_FEASIBILITY_ANSWERED,
		MessageSourceType.SUPPLIER_ENROLLMENT_NOTICE_ADJUSTED_ANSWERED,
		MessageSourceType.SUPPLIER_ENROLLMENT_NOTICE_REPRESENTATION_ANSWERED
	])
	supplierEnrollmentNoticeStatus!: SupplierEnrollmentNoticeStatus
	supplierEnrollmentNotices: Array<SupplierEnrollmentNotice> = []
	supplierEnrollmentNoticeAttachment!: SupplierEnrollmentNoticeAttachment
	supplierEnrollmentNoticeMessageType!: SupplierEnrollmentNoticeMessageType
	supplierEnrollmentNotice$: Observable<Paginate<SupplierEnrollmentNotice>> = emptyPaginateObservable()

	supplierEnrollmentCounterargumentLoading: boolean
	supplierEnrollmentCounterarguments: Array<SupplierEnrollmentNoticeCounterargument> = []

	fileUploadAttachmentDocument: FileUploadAttachment
	expiresAtControl = new FormControl(null)
	descriptionControl = new FormControl(null)
	counterarguments$: Observable<Paginate<SupplierEnrollmentNoticeCounterargument>>

	supplierEnrollmentNoticeCounterargument: SupplierEnrollmentNoticeCounterargument
	supplierEnrollmentNoticeCounterargumentStatus: SupplierEnrollmentNoticeCounterargumentStatus

	attachmentResponsibleExpenseManagement: any
	contractEstimates: ContractEstimateRow[] = []

	participantEventsLoading: boolean
	participantEvents: SupplierEnrollmentNoticeMessageItem[] = []

	formAttachment = new FormGroup({
		file: new FormControl(null, Validators.compose([Validators.required])),
		description: new FormControl(null, Validators.compose([Validators.required]))
	})


	activities!: Array<LogActivity>
	modalProposalType: ModalProposalType
	hasAnyProposalInBids = false
	trading!: SupplierEnrollmentNoticeTrading
	items$: Observable<Array<DemandIntentDocumentProcessItem>> = EMPTY
	tradingAllItemsWithLatestProposal: DemandIntentDocumentProcessItem[] = []
	tradingItemsWithLatestProposal: DemandIntentDocumentProcessItem[] = []
	adjusted$: Observable<Array<SupplierEnrollmentNoticeAdjusted>> = EMPTY
	feasibility$: Observable<Array<SupplierEnrollmentNoticeFeasibility>> = EMPTY

	private tradingSelectedItemIds = new Set<string>()

	protected readonly DateUtil = DateUtil
	protected readonly DateValidator = DateValidator
	protected readonly ProcessModality = ProcessModality
	protected readonly SupplierEnrollmentNoticeStatus = SupplierEnrollmentNoticeStatus
	protected readonly EnrollmentNoticeTradingStatus = SupplierEnrollmentNoticeTradingStatus
	protected readonly CounterargumentStatus = SupplierEnrollmentNoticeCounterargumentStatus
	protected readonly SupplierEnrollmentNoticeMessageType = SupplierEnrollmentNoticeMessageType
	protected readonly SupplierEnrollmentNoticeAttachmentType = SupplierEnrollmentNoticeAttachmentType

	constructor(
		private modal: NgbModal,
		private mask: NgxMaskPipe,
		public label: LabelService,
		private toast: ToastService,
		private sanitize: DomSanitizer,
		private zipService: ZipService,
		private alertfy: AlertifyService,
		public accountService: AccountService,
		public olDateTimeIntl: OwlDateTimeIntl,
		private uploadS3Service: UploadS3Service,
		private attachmentService: AttachmentService,
		private webSocketService: NotificationSocketService,
		private changeDetectorRef: ChangeDetectorRef,
		private noticeSessionService: NoticeSessionService,
		private pncpOrganizationService: PncpOrganizationService,
		private documentGeneratorService: DocumentGeneratorService,
		private documentGeneratorProvider: DocumentGeneratorProvider,
		public demandIntentDocumentService: DemandIntentDocumentService,
		private supplierEnrollmentNoticeService: SupplierEnrollmentNoticeService,
		public demandIntentDocumentItemService: DemandIntentDocumentItemService,
		private noticeSessionRepresentationService: NoticeSessionRepresentationService,
		private supplierEnrollmentNoticeTradingService: SupplierEnrollmentNoticeTradingService,
		private enrollmentCounterargumentService: SupplierEnrollmentNoticeCounterargumentService,
		private supplierEnrollmentNoticeProposalService: SupplierEnrollmentNoticeProposalService,
		private noticeSessionPhaseBidService: NoticeSessionPhaseBidService,
		private chatRoomService: ChatRoomService,
		private supplierEnrollmentNoticeAdjustedService: SupplierEnrollmentNoticeAdjustedService,
		private supplierEnrollmentNoticeQualificationService: SupplierEnrollmentNoticeQualificationService,
		private supplierEnrollmentNoticeFeasibilityService: SupplierEnrollmentNoticeFeasibilityService,
		private supplierEnrollmentNoticeMessageService: SupplierEnrollmentNoticeMessageService
	) {
		OwlDateTimeIntlPtBr.setLabels(olDateTimeIntl)
	}

	ngOnInit() {
		this.fetchSuppliersEnrollmentNotice()
		this.startSilentParticipantsRefresh()
		this.fetchBidPhasesFinishedState()
		this.fetchParticipantNicknames()
	}

	/**
	 * Pregão/Concorrência: enquanto as fases de lances não terminarem, o que o participante enviou é
	 * a "Proposta Inicial" — só depois delas o conjunto (inicial + lances/negociação) vira
	 * "Propostas". A flag alimenta o rótulo do menu e do modal; sem fase cadastrada a disputa nem
	 * começou, então continua "Proposta Inicial".
	 */
	private fetchBidPhasesFinishedState() {
		const sessionId = this.demand?.noticeSession?.id
		if (!sessionId || !this.demand?.isDisputeWithBids) return

		this.noticeSessionPhaseBidService
			.search(new NoticeSessionPhaseBidSearch({ sessionId }), new HttpParams().set('size', '100'))
			.subscribe(response => {
				const phases = (response?.content ?? []).filter(it => it?.status !== NoticeSessionPhaseBidStatus.CANCELED)
				this.bidPhasesAllFinished = phases.length > 0 && phases.every(it => it.status === NoticeSessionPhaseBidStatus.CLOSED)
			})
	}

	ngOnDestroy() {
		this.stopPoolingSupplierPublish()
		this.destroy$.next()
		this.destroy$.complete()
		this.participantEventsCancel$.next()
		this.participantEventsCancel$.complete()
		this.contractEstimates = []
		this.documentGeneratorProvider.destroy()
	}

	private startSilentParticipantsRefresh() {
		this.webSocketService.connect()

		this.webSocketService.incoming$.pipe(takeUntil(this.destroy$)).subscribe(message => {
			if (!message || message.type !== NotificationType.WS || !message.sourceEnrollmentId) return
			if (!this.agentParticipantUpdateTypes.has(message.sourceType)) return

			this.refreshParticipantSilently(message.sourceEnrollmentId)
		})
	}

	private refreshParticipantSilently(enrollmentId: string) {
		const current = this.currentParticipants.find(it => it.id === enrollmentId)

		if (!current) {
			return
		}

		this.supplierEnrollmentNoticeService.detail(enrollmentId).subscribe(fresh => {
			Object.assign(current, fresh)
		})
	}

	modalSupplierAction(item: SupplierEnrollmentNotice, status: SupplierEnrollmentNoticeStatus, type?: SupplierEnrollmentNoticeMessageType) {
		this.supplierEnrollmentNotice = item
		this.supplierEnrollmentNoticeStatus = status

		if (!type) {
			this.supplierEnrollmentNoticeMessageType = SupplierEnrollmentNoticeMessageType.DOCUMENTATION

			if (this.supplierEnrollmentNotice.statusCreated && this.supplierEnrollmentNotice.appeal) {
				this.supplierEnrollmentNoticeMessageType = SupplierEnrollmentNoticeMessageType.APPEAL
			}
		} else {
			this.supplierEnrollmentNoticeMessageType = type
		}

		this.descriptionControl.setValue(null)
		this.fileUploadAttachmentDocument = null

		this.modal.open(this.modalConfirmJudgingSupplier, { size: 'lg', keyboard: false, backdrop: 'static' })
	}

	loosePublishSupplier() {
		this.modal.open(this.modalPublishLooseOther, { size: 'lg', keyboard: false, backdrop: 'static' })
		this.fetchAllSuppliersEnrollmentNoticeReady().subscribe(content => (this.supplierEnrollmentNotices = content))
	}

	looseClosed() {
		this.alertfy.confirm(
			`Fechar Sessão`,
			'Deseja fechar a sessão deste processo? Após o fechamento novos participantes não poderão entrar!',
			async event => {
				if (event.confirmed) {
					this.submitted = true
					this.supplierEnrollmentNotices = await firstValueFrom(this.fetchAllSuppliersEnrollmentNoticePending())

					if (this.supplierEnrollmentNotices.length > 0) {
						this.submitted = false
						this.descriptionControl.setValue(null)
						this.modal.open(this.modalRejectedSupplierPending, { size: 'lg' })
					} else {
						this.supplierEnrollmentCounterarguments = await firstValueFrom(this.fetchAllSuppliersEnrollmentCounterargumentPending())

						if (this.supplierEnrollmentCounterarguments.length > 0) {
							this.submitted = false
							this.modal.open(this.modalCounterargumentSupplierPending, { size: 'lg' })
							return
						}

						this.demandIntentDocumentService
							.done(this.demand.id)
							.pipe(finalize(() => (this.submitted = false)))
							.subscribe({
								next: () => {
									this.fetchSuppliersEnrollmentNotice()
									this.toast.success('Sessão fechada com sucesso!')
									this.demand.status = DemandIntentDocumentStatus.DONE
									this.demand.noticeSession.status = NoticeSessionStatus.CLOSED
								}
							})
					}
				}
			}
		)
	}

	looseOpened() {
		this.alertfy.confirm(`Abrir Sessão`, 'Deseja realmente abrir a sessão deste processo? Após aberto novos participantes poderão participar!', event => {
			if (event.confirmed) {
				this.submitted = true
				this.demandIntentDocumentService
					.reopen(this.demand.id, DemandIntentDocumentPublishStatus.DONE)
					.pipe(finalize(() => (this.submitted = false)))
					.subscribe(() => {
						this.fetchSuppliersEnrollmentNotice()
						this.toast.success('Sessão aberta com sucesso!')
						this.demand.status = DemandIntentDocumentStatus.STARTED
						this.demand.noticeSession.status = NoticeSessionStatus.OPENED
					})
			}
		})
	}

	looseLocked() {
		this.alertfy.confirm(
			`Entrada de Participantes`,
			`Deseja <b>${this.demand.noticeSession.locked ? 'desbloquear' : 'bloquear'}</b> a sessão para entrada de novos participantes? Essa operação pode ser desfeita a qualquer momento!`,
			async event => {
				if (event.confirmed) {
					this.submittedLocking = true
					const locked = !this.demand.noticeSession.locked

					this.noticeSessionService
						.locked(this.demand.noticeSession.id, locked)
						.pipe(finalize(() => (this.submittedLocking = false)))
						.subscribe(() => {
							this.demand.noticeSession.locked = locked
							this.toast.success('Operação realizada com sucesso!')
						})
				}
			}
		)
	}

	/**
	 * Encerramento forçado (spec 024) — fura-fluxo com justificativa obrigatória, disponível para
	 * qualquer modalidade e qualquer status não encerrado forçadamente. Diferente do fechamento
	 * normal, este estado é terminal — a tela reflete isso escondendo as três ações depois.
	 */
	sessionForcedClosed() {
		const { id } = this.demand.noticeSession

		const message = `Após realizar o encerramento não será possível reabrir a sessão! <br><br>Justificativa do encerramento`

		this.alertfy.prompt('Encerrar Sessão', message, event => {
			if (!event.confirmed) return

			const justification = event.value?.trim()

			if (!justification) {
				this.toast.warn('Informe a justificativa do encerramento.')
				return
			}

			this.submitted = true
			this.noticeSessionService
				.forcedClosed(id, justification)
				.pipe(finalize(() => (this.submitted = false)))
				.subscribe(() => {
					this.fetchSuppliersEnrollmentNotice()
					this.toast.success('Sessão encerrada com sucesso!')
					this.demand.noticeSession.status = NoticeSessionStatus.CLOSED
					this.demand.noticeSession.forcedClosure = true
					this.demand.noticeSession.forcedClosureJustification = justification
				})
		})
	}

	saveRepresentation() {
		const message = this.descriptionControl.value
		let expiresAt = this.expiresAtControl.value

		if (this.demand.noticeSession.statusClosed) {
			this.toast.warn('Não é possível enviar diligência com a sessão fechada!')
			return
		}

		if (!message && !expiresAt) {
			this.toast.warn('Informe o prazo e a mensagem para continuar!')
			return
		}

		expiresAt = momentTz.tz(expiresAt, 'America/Fortaleza').format(`YYYY-MM-DDTHH:mm:ss`)

		this.submittedRepresentation = true

		const entity = new NoticeSessionRepresentation({
			message,
			expiresAt,
			noticeSession: new NoticeSession({ id: this.demand.noticeSession.id }),
			enrollment: new SupplierEnrollmentNotice({ id: this.supplierEnrollmentNotice.id })
		})

		this.noticeSessionRepresentationService.save(entity).subscribe({
			next: () => {
				this.supplierEnrollmentNoticeService
					.detail(this.supplierEnrollmentNotice.id)
					.pipe(
						finalize(() => {
							this.listableRepresentations = true
							this.submittedRepresentation = false
						})
					)
					.subscribe(response => {
						this.supplierEnrollmentNotice = response
					})

				this.expiresAtControl.setValue(null)
				this.descriptionControl.setValue(null)
				this.toast.success('Enviado com sucesso')
			},
			error: () => {
				this.submittedRepresentation = false
			}
		})
	}

	updateRepresentation() {
		const message = this.descriptionControl.value
		let expiresAt = this.expiresAtControl.value

		if (this.demand.noticeSession.statusClosed) {
			this.toast.warn('Não é possível enviar diligência com a sessão fechada!')
			return
		}

		if (!message && !expiresAt) {
			this.toast.warn('Informe o prazo e a mensagem para continuar!')
			return
		}

		expiresAt = momentTz.tz(expiresAt, 'America/Fortaleza').format(`YYYY-MM-DDTHH:mm:ss`)

		this.submittedRepresentation = true

		const entity = new NoticeSessionRepresentation({ expiresAt, message })

		this.noticeSessionRepresentationService
			.update(this.noticeSessionRepresentation.id, entity)
			.pipe(
				finalize(() => {
					this.listableRepresentations = true
					this.submittedRepresentation = false
				})
			)
			.subscribe({
				next: () => {
					this.expiresAtControl.setValue(null)
					this.descriptionControl.setValue(null)
					this.noticeSessionRepresentation.message = message
					this.noticeSessionRepresentation.expiresAt = expiresAt
					this.toast.success('Atualizado com sucesso')
				}
			})
	}

	saveTrading() {
		const message = this.descriptionControl.value

		if (this.demand.noticeSession.statusClosed) {
			this.toast.warn('Não é possível enviar diligência com a sessão fechada!')
			return
		}

		if (!message) {
			this.toast.warn('Informe a mensagem para continuar!')
			return
		}

		this.alertfy.confirm('Salvar', 'Deseja realmente abrir uma negociação?', event => {
			if (event.confirmed) {
				const selectedProposals = this.tradingSelectedProposals

				if (selectedProposals.length === 0) {
					this.toast.warn('Selecione ao menos um item para negociação.')
					return
				}

				const request = new SupplierEnrollmentNoticeTradingRequest({
					description: message,
					proposals: selectedProposals,
					enrollment: new SupplierEnrollmentNotice({ id: this.supplierEnrollmentNotice.id }),
					session: new NoticeSession({ id: this.supplierEnrollmentNotice.noticeSession.id })
				})

				this.submittedProposal = true
				this.supplierEnrollmentNoticeTradingService
					.save(request)
					.pipe(finalize(() => (this.submittedProposal = false)))
					.subscribe(() => {
						this.modal.dismissAll()
						this.fetchSuppliersEnrollmentNotice()
						this.toast.success('Salvo com sucesso')
					})
			}
		})
	}

	saveFeasibilityAdjustedProposal() {
		const description = this.descriptionControl.value
		let expiresAt = this.expiresAtControl.value

		if (this.demand.noticeSession.statusClosed) {
			this.toast.warn('Não é possível realizar operações com a sessão fechada!')
			return
		}

		if (!description && !expiresAt) {
			this.toast.warn('Informe a data de expiração e a descrição para continuar!')
			return
		}

		expiresAt = momentTz.tz(expiresAt, 'America/Fortaleza').format(`YYYY-MM-DDTHH:mm:ss`)

		const enrollmentId = this.supplierEnrollmentNotice.id
		const sessionId = this.supplierEnrollmentNotice.noticeSession.id
		const request = {
			expiresAt,
			description,
			session: new NoticeSession({ id: sessionId }),
			enrollment: new SupplierEnrollmentNotice({ id: enrollmentId })
		}

		if (this.modalProposalType === 'adjusted' && !this.demand?.noticeSession?.statusOpened) {
			this.toast.warn('A sessão não está em andamento — não é possível incluir proposta readequada.')
			return
		}

		const source =
			this.modalProposalType === 'feasibility'
				? this.supplierEnrollmentNoticeFeasibilityService.save(new SupplierEnrollmentNoticeFeasibilityRequest(request))
				: this.supplierEnrollmentNoticeAdjustedService.save(new SupplierEnrollmentNoticeAdjustedRequest(request))

		this.submittedProposal = true

		source.pipe(finalize(() => (this.submittedProposal = false))).subscribe(() => {
			this.listableProposal = true
			this.toast.success('Operação realizada com sucesso!')
			this.fetchAllFeasibilityAdjustedProposal(this.modalProposalType, sessionId, enrollmentId)
		})
	}

	closeOpenFeasibility(item: SupplierEnrollmentNoticeFeasibility, closed = true) {
		this.alertfy.prompt(
			'Atenção',
			`Deseja realmente realizar ${closed ? 'o fechamento' : 'a abertura'} dessa exequibilidade? <br> Favor definir abaixo uma descrição.`,
			event => {
				if (event.confirmed) {
					item.submitted = true
					const source = closed
						? this.supplierEnrollmentNoticeFeasibilityService.closed(item.id, event.value)
						: this.supplierEnrollmentNoticeFeasibilityService.opened(item.id, event.value)

					source.pipe(finalize(() => (item.submitted = false))).subscribe(() => {
						this.toast.success('Realizado com sucesso')
						item.status = closed ? SupplierEnrollmentNoticeFeasibilityStatus.CLOSED : SupplierEnrollmentNoticeFeasibilityStatus.OPENED
					})
				}
			}
		)
	}

	closeOpenAdjusted(item: SupplierEnrollmentNoticeAdjusted, closed = true) {
		this.alertfy.prompt(
			'Atenção',
			`Deseja realmente realizar ${closed ? 'o fechamento' : 'a abertura'} dessa proposta readequada? <br> Favor definir abaixo uma descrição.`,
			event => {
				if (event.confirmed) {
					item.submitted = true
					const source = closed
						? this.supplierEnrollmentNoticeAdjustedService.closed(item.id, event.value)
						: this.supplierEnrollmentNoticeAdjustedService.opened(item.id, event.value)

					source.pipe(finalize(() => (item.submitted = false))).subscribe(() => {
						this.toast.success('Realizado com sucesso')
						item.status = closed ? SupplierEnrollmentNoticeAdjustedStatus.CLOSED : SupplierEnrollmentNoticeAdjustedStatus.OPENED
					})
				}
			}
		)
	}

	updateTrading(status: SupplierEnrollmentNoticeTradingStatus) {
		const message = this.descriptionControl.value

		if (!message) {
			this.toast.warn('Informe a mensagem para continuar!')
			return
		}

		if (status === SupplierEnrollmentNoticeTradingStatus.OPENED && !this.hasTradingSelectedItems) {
			this.toast.warn('Selecione ao menos um item para negociação.')
			return
		}

		const statusLabel = status === SupplierEnrollmentNoticeTradingStatus.OPENED ? 'aberto' : 'fechado'

		this.alertfy.confirm('Atenção', `Deseja realmente ${statusLabel} uma negociação?`, event => {
			if (event.confirmed) {
				this.submittedProposal = true

				const source =
					status === SupplierEnrollmentNoticeTradingStatus.OPENED
						? this.supplierEnrollmentNoticeTradingService.opened(this.trading.id, this.tradingSelectedProposals, message)
						: this.supplierEnrollmentNoticeTradingService.closed(this.trading.id, this.tradingSelectedProposals, message)

				source.pipe(finalize(() => (this.submittedProposal = false))).subscribe(() => {
					this.modal.dismissAll()
					this.fetchSuppliersEnrollmentNotice()
					this.toast.success('Salvo com sucesso')
				})
			}
		})
	}

	proposalQualify(action: 'inapposite' | 'appropriate') {
		// Inversão de fases (spec 047): aceitar a proposta inicial é HABILITAR e rejeitar é INABILITAR — o
		// julgamento da habilitação vem antes dos lances. O ato no servidor é o mesmo (appropriate/inapposite);
		// muda só o que a tela diz. O nome segue a régua de sigilo da lista.
		const qualificationInversion = !!this.demand?.qualificationInversion
		const participantName = qualificationInversion
			? this.participantDisplayName(this.supplierEnrollmentNotice)
			: this.supplierEnrollmentNotice?.supplier?.name

		const onSubscribeAction = () => {
			this.modal.dismissAll()
			this.fetchSuppliersEnrollmentNotice()

			if (qualificationInversion) {
				this.toast.success(action === 'appropriate' ? 'Participante habilitado.' : 'Participante inabilitado.')
			} else {
				this.toast.success('Operação realizada com sucesso')
			}

			this.supplierEnrollmentNoticeTradingService
				.latest(this.supplierEnrollmentNotice.noticeSession.id, this.supplierEnrollmentNotice.id)
				.subscribe(trading => {
					if (this.supplierEnrollmentNotice.statusProposalTrading && trading.statusOpened) {
						this.modalTrades(this.supplierEnrollmentNotice)
					} else {
						this.supplierEnrollmentNotice = null
					}
				})
		}

		if (action === 'appropriate') {
			// Sem documentação a decisão continua do agente (RF-16): a falta só fica em evidência.
			const missingDocumentation = qualificationInversion && !this.hasQualificationDocumentation(this.supplierEnrollmentNotice)
			const message = qualificationInversion
				? `Deseja realmente habilitar o licitante ${participantName}?<br><br>Na inversão de fases, aceitar a proposta inicial é o julgamento da habilitação: habilitado, o licitante segue para a disputa de lances.` +
					(missingDocumentation ? '<br><br><b>Atenção:</b> o licitante não enviou documentação de habilitação.' : '')
				: `Deseja realmente aceitar a proposta do licitante ${participantName}?`

			this.alertfy.confirm(qualificationInversion ? 'Habilitar licitante' : 'Atenção', message, event => {
				if (event.confirmed) {
					const enrollmentId = this.supplierEnrollmentNotice.id
					const sessionId = this.supplierEnrollmentNotice.noticeSession.id
					this.submittedProposalAppropriate = true

					this.supplierEnrollmentNoticeProposalService
						.appropriate(sessionId, enrollmentId)
						.pipe(finalize(() => (this.submittedProposalAppropriate = false)))
						.subscribe(() => onSubscribeAction())
				}
			})
		} else if (action === 'inapposite') {
			// PC-11: fora da inversão, a recusa exige um motivo da lista fechada (IN SEGES/ME 73/2022, art. 21, § 4º, e
			// Lei 14.133/2021, art. 59), que o servidor confere e leva à ata. Na inversão a recusa é a inabilitação.
			if (!qualificationInversion) {
				this.inappositeReason = null
				this.inappositeDescription = ''
				this.inappositeDone = onSubscribeAction
				this.modal.open(this.modalProposalInapposite, { centered: true })
				return
			}

			this.alertfy.prompt(
				'Inabilitar licitante',
				`Deseja realmente inabilitar o licitante ${participantName}?<br><br>Na inversão de fases, rejeitar a proposta inicial é o julgamento da habilitação: inabilitado, o licitante sai da disputa. Para continuar, favor informar o motivo dessa ação.`,
				event => {
					if (event.confirmed) {
						const enrollmentId = this.supplierEnrollmentNotice.id
						const sessionId = this.supplierEnrollmentNotice.noticeSession.id

						if (!event.value) {
							this.toast.warn('Favor informar o motivo da sua ação!')
							return
						}

						this.submittedProposalInapposite = true
						this.supplierEnrollmentNoticeProposalService
							.inapposite(sessionId, enrollmentId, event.value)
							.pipe(finalize(() => (this.submittedProposalInapposite = false)))
							.subscribe(() => onSubscribeAction())
					}
				}
			)
		}
	}

	/**
	 * Explicação do selo "Sigiloso", que só aparece no lance que o servidor marca com `sealed`. Antes da abertura, o servidor
	 * sela o valor (PC-01), mas não para a Administração na Dispensa sem disputa, que vê valor e ordem desde o envio
	 * (decisão de 14/10/2026). Depois da abertura, só o fechado e aberto sela, até a fase abrir.
	 */
	get sealedProposalHint(): string {
		return this.demand?.noticeSession?.statusCreated
			? 'Proposta sigilosa até a abertura da sessão (Lei 14.133/2021, art. 13, parágrafo único, I)'
			: 'Proposta sigilosa — o valor será revelado na abertura da fase de lances'
	}

	confirmProposalInapposite() {
		if (!this.inappositeReason) {
			this.toast.warn('Selecione o motivo da recusa da proposta.')
			return
		}

		const enrollmentId = this.supplierEnrollmentNotice.id
		const sessionId = this.supplierEnrollmentNotice.noticeSession.id

		this.submittedProposalInapposite = true
		this.supplierEnrollmentNoticeProposalService
			.inapposite(sessionId, enrollmentId, this.inappositeDescription?.trim() || null, this.inappositeReason)
			.pipe(finalize(() => (this.submittedProposalInapposite = false)))
			.subscribe(() => this.inappositeDone?.())
	}

	sessionMessageAttachmentDownload(item: NoticeSessionMessage, resourceId: string) {
		this.attachmentDownloadResolver(item, resourceId)
	}

	enrollmentMessageAttachmentDownload(item: SupplierEnrollmentNoticeMessage, resourceId: string) {
		this.attachmentDownloadResolver(item, resourceId)
	}

	unpublishSupplierLooseOther(item: SupplierEnrollmentNotice) {
		this.alertfy.confirm('Atenção', `Deseja realmente remover o documento do <b>${item.supplier.name}</b> do PNCP?`, event => {
			if (event.confirmed) {
				item.deleting = true

				this.pncpOrganizationService.publishRemoveFileSupplier(this.demand.id, item.id).subscribe({
					next: () => {
						this.supplierEnrollmentNoticeService
							.unpublishConfirmed(item.id)
							.pipe(finalize(() => (item.deleting = false)))
							.subscribe(() => {
								item.published = false
								this.toast.success('Documento removido com sucesso do PNCP')
							})
					},
					error: () => (item.deleting = false)
				})
			}
		})
	}

	attachmentSupplierToPDFDownload(item: SupplierEnrollmentNotice, type: SupplierEnrollmentNoticeAttachmentType, showModal = true) {
		this.noticeAttachment = false
		this.attachmentLoading = true
		this.supplierEnrollmentNotice = item
		this.supplierEnrollmentNoticeAttachment = item.attachments.find(it => it.type === type)

		if (!this.supplierEnrollmentNoticeAttachment) {
			this.toast.warn('Anexo não encontrado')
			return
		}

		if (showModal) {
			this.modal.open(this.modalAttachmentView, { fullscreen: true })
		}

		let documentType =
			this.demand.process.modality === ProcessModality.PRE_QUALIFICATION
				? DocumentGeneratorType.NOTICE_CERTIFICATED_PRE_QUALIFICATION
				: DocumentGeneratorType.NOTICE_CERTIFICATED_ACCREDITATION

		this.attachmentTitle =
			documentType === DocumentGeneratorType.NOTICE_CERTIFICATED_ACCREDITATION ? 'Termo de Credenciamento do Fornecedor' : 'Certificado do Fornecedor'

		if (type === SupplierEnrollmentNoticeAttachmentType.ANALYTICS) {
			this.attachmentTitle = 'Relatório de Analise'
			documentType = DocumentGeneratorType.REPORT_ANALYTICS_PQ_ACCREDITATION
		}

		const request = new DocumentGeneratorRequest<BaseDocument>({
			documentType,
			sourceId: this.supplierEnrollmentNoticeAttachment.id
		})

		this.documentGeneratorService.convertPdf(request).subscribe({
			next: response => {
				if (response.status === 'error') {
					this.attachmentUrl = 'error'
					this.attachmentLoading = false
				} else {
					this.attachmentService
						.streamingById(response.id)
						.pipe(finalize(() => (this.attachmentLoading = false)))
						.subscribe({
							next: data => {
								const file = new Blob([data], { type: 'application/pdf' })
								const reportBlobUrl = URL.createObjectURL(file)
								this.attachmentUrl = this.sanitize.bypassSecurityTrustResourceUrl(reportBlobUrl)
							}
						})
				}
			},
			error: () => (this.attachmentUrl = 'error')
		})
	}

	counterargumentAttachmentDownload(item: SupplierEnrollmentNoticeCounterargument, judging = false) {
		if (this.attachmentLoading) {
			return
		}

		let attachmentId = item.principalAttachmentId

		if (judging) {
			item.judgingDownloading = true
			attachmentId = item.judgingAttachmentId
		} else {
			item.submitted = true
		}

		this.attachmentLoading = true

		this.attachmentService
			.downloadHandleBlob(attachmentId)
			.pipe(
				finalize(() => {
					item.submitted = false
					this.attachmentLoading = false
					item.judgingDownloading = false
				})
			)
			.subscribe(response => {
				this.attachmentUrl = response
				this.modal.open(this.modalAttachment, { fullscreen: true })
			})
	}

	modalCounterargument(item: SupplierEnrollmentNotice) {
		this.fileAttachmentControl.setValue(null)

		this.supplierEnrollmentNotice = item
		this.supplierEnrollmentNotice.counterarguments = true
		this.counterarguments$ = this.enrollmentCounterargumentService.searchSupplier(item.id)
		this.modal.open(this.modalCounterarguments, { size: 'lg', keyboard: false, backdrop: 'static' })
	}

	async modalRepresentation(item: SupplierEnrollmentNotice) {
		this.expiresAtControl.reset()
		this.descriptionControl.reset()

		this.listableRepresentations = true
		this.supplierEnrollmentNotice = item

		try {
			this.supplierEnrollmentNotice = await firstValueFrom(this.supplierEnrollmentNoticeService.detail(item.id))
		} catch (error) {
			console.error(error)
		}

		const modal = this.modal.open(this.modalRequestRepresentation, { backdrop: 'static', size: 'lg', keyboard: false })

		modal.closed.subscribe(() => {
			this.expiresAtControl.reset()
			this.descriptionControl.reset()

			this.supplierEnrollmentNotice = null
		})
		modal.dismissed.subscribe(() => {
			this.expiresAtControl.reset()
			this.descriptionControl.reset()

			this.supplierEnrollmentNotice = null
		})
	}

	modalGenerateCertificate(item: SupplierEnrollmentNotice, status: SupplierEnrollmentNoticeStatus, force = false) {
		this.forceGenerateDocuments = force
		this.supplierEnrollmentNotice = item
		this.submittedGenerateAnalytics = false
		this.submittedGenerateCertificate = false
		this.supplierEnrollmentNoticeStatus = status
		this.modal.open(this.modalConfirmCertificate, { size: 'lg', keyboard: false, backdrop: 'static' })
	}

	modalCounterargumentJudging(item: SupplierEnrollmentNoticeCounterargument, status: SupplierEnrollmentNoticeCounterargumentStatus) {
		this.descriptionControl.setValue(null)

		this.confirmSubmitted = false
		this.fileUploadAttachmentDocument = null
		this.supplierEnrollmentNoticeCounterargument = item
		this.supplierEnrollmentNoticeCounterargumentStatus = status
		this.modalGratedCounterargumentRef = this.modal.open(this.modalGratedCounterargument, { size: 'lg', keyboard: false, backdrop: 'static' })
	}

	modalBids(item: SupplierEnrollmentNotice) {
		this.loadItemsWithProposals(item)
		this.supplierEnrollmentNotice = item
		this.modal.open(this.modalBidding, { backdrop: 'static', size: 'xl', keyboard: false })
	}

	modalTrades(item: SupplierEnrollmentNotice) {
		this.supplierEnrollmentNotice = item
		this.descriptionControl.setValue(null)

		this.loadItemsWithProposals(item, true)
		this.loadTrades(item, true)

		const modal = this.modal.open(this.modalTrading, { backdrop: 'static', size: 'lg', keyboard: false })

		modal.dismissed.subscribe(() => {
			this.descriptionControl.setValue(null)
			this.clearTradingSelection()
		})

		modal.closed.subscribe(() => {
			this.descriptionControl.setValue(null)
			this.clearTradingSelection()
		})
	}

	modalFeasibilityAdjustedProposal(item: SupplierEnrollmentNotice, type: ModalProposalType) {
		this.listableProposal = true
		this.modalProposalType = type
		this.supplierEnrollmentNotice = item
		this.descriptionControl.setValue(null)
		this.expiresAtControl.setValue(null)

		const modal = this.modal.open(this.modalFeasibilityAdjusted, { backdrop: 'static', size: 'lg', keyboard: false })

		this.fetchAllFeasibilityAdjustedProposal(type, item.noticeSession.id, item.id)

		modal.dismissed.subscribe(() => {
			this.descriptionControl.setValue(null)
			this.expiresAtControl.setValue(null)
		})

		modal.closed.subscribe(() => {
			this.descriptionControl.setValue(null)
			this.expiresAtControl.setValue(null)
		})
	}

	refreshFeasibilityAdjustedProposalList() {
		if (!this.supplierEnrollmentNotice?.noticeSession?.id || !this.supplierEnrollmentNotice?.id || !this.modalProposalType) {
			return
		}

		this.fetchAllFeasibilityAdjustedProposal(this.modalProposalType, this.supplierEnrollmentNotice.noticeSession.id, this.supplierEnrollmentNotice.id)
	}

	modalLogActives(item: SupplierEnrollmentNotice) {
		this.supplierEnrollmentNotice = item
		this.activities = LogActivity.getAllActives({ disputeWithBids: !!this.demand?.isDisputeWithBids })

		const enrollmentId = item.id
		const sessionId = item.noticeSession.id

		for (const activity of this.activities) {
			activity.actionDetected(item)

			if (activity.step === 'TRADES') {
				this.supplierEnrollmentNoticeTradingService.latest(sessionId, enrollmentId).subscribe(response => {
					if (response && response?.id) {
						const statusClosed = SupplierEnrollmentNoticeTradingStatus.CLOSED
						const statusInapposite = SupplierEnrollmentNoticeStatus.PROPOSAL_INAPPOSITE

						activity.date = response.updated
						activity.action = response.status === statusClosed && item.status === statusInapposite ? 'DANGER' : 'DONE'
					}

					activity.loading = false
				})
			}

			if (activity.step === 'FEASIBILITY') {
				this.supplierEnrollmentNoticeFeasibilityService.latest(sessionId, enrollmentId).subscribe(response => {
					if (response && response?.id) {
						const statuses = [SupplierEnrollmentNoticeFeasibilityStatus.ANSWER, SupplierEnrollmentNoticeFeasibilityStatus.CLOSED]

						activity.date = response.updated
						activity.action = statuses.includes(response.status) ? 'DONE' : 'UNKNOWN'
					}

					activity.loading = false
				})
			}

			if (activity.step === 'ADJUSTED') {
				this.supplierEnrollmentNoticeAdjustedService.latest(sessionId, enrollmentId).subscribe(response => {
					if (response) {
						const statuses = [SupplierEnrollmentNoticeAdjustedStatus.ANSWER, SupplierEnrollmentNoticeAdjustedStatus.CLOSED]

						activity.date = response.updated
						activity.action = statuses.includes(response.status) ? 'DONE' : 'UNKNOWN'
					}

					activity.loading = false
				})
			}
		}

		const modal = this.modal.open(this.modalLogAction, { backdrop: 'static', size: 'lg' })

		modal.closed.subscribe(() => (this.supplierEnrollmentNotice = null))
		modal.dismissed.subscribe(() => (this.supplierEnrollmentNotice = null))
	}

	modalEnrollmentEvents(item: SupplierEnrollmentNotice) {
		this.participantEventsCancel$.next()

		this.supplierEnrollmentNotice = item
		this.participantEvents = []
		this.participantEventsLoading = true

		const modal = this.modal.open(this.modalParticipantEvents, { backdrop: 'static', size: 'lg' })

		modal.closed.subscribe(() => {
			this.supplierEnrollmentNotice = null
			this.participantEventsCancel$.next()
		})
		modal.dismissed.subscribe(() => {
			this.supplierEnrollmentNotice = null
			this.participantEventsCancel$.next()
		})

		this.supplierEnrollmentNoticeMessageService
			.list(item.id)
			.pipe(
				takeUntil(this.participantEventsCancel$),
				takeUntil(this.destroy$),
				finalize(() => (this.participantEventsLoading = false))
			)
			.subscribe({
				next: response => (this.participantEvents = response),
				error: () => (this.participantEvents = [])
			})
	}

	get participantEventGroups(): SessionTimelineGroup<SupplierEnrollmentNoticeMessageItem>[] {
		return groupSessionTimelineByDate(this.participantEvents)
	}

	protected eventSourceIcon = eventSourceIcon

	participantEventAttachmentDownload(item: SupplierEnrollmentNoticeMessageItem, resourceId: string) {
		this.attachmentDownloadResolver(item, resourceId)
	}

	modalAttachmentSupplierDownload(item: SupplierEnrollmentNotice, type: SupplierEnrollmentNoticeAttachmentType, attachmentSidebar = false, download = true) {
		this.noticeAttachment = false
		this.supplierEnrollmentNotice = item
		this.attachmentSidebar = attachmentSidebar
		this.supplierEnrollmentNoticeAttachment = item.attachments.find(it => it.type === type)

		if (!this.supplierEnrollmentNoticeAttachment) {
			this.toast.warn('Modelo para o Anexo não encontrado')
			return
		}

		item.attachments.forEach(it => {
			it.documentation = this.supplierEnrollmentNoticeAttachment.id === it.id
		})

		this.modal.open(this.modalAttachmentViewSupplier, { fullscreen: true })

		if (download) {
			this.supplierEnrollmentNotice.submitted = true
			this.attachmentService.downloadHandleBlob(this.supplierEnrollmentNoticeAttachment.id).subscribe(url => {
				this.supplierEnrollmentNotice.url = url
				this.supplierEnrollmentNotice.submitted = false
			})
		}
	}

	/** Anexa à lista de documentação os PDFs das propostas readequadas já respondidas (spec 026/ajustes 2026-09-05). */
	private appendAdjustedProposalAttachments(item: SupplierEnrollmentNotice) {
		const sessionId = item?.noticeSession?.id
		if (!sessionId || !item?.id || !item?.demand?.isDispute) return

		this.supplierEnrollmentNoticeAdjustedService.listable(sessionId, item.id).subscribe(adjustedList => {
			const answers = (adjustedList ?? []).filter(it => it.latestAnswer?.hasAttachment && it.latestAnswer?.id)
			if (answers.length === 0) return

			const existingIds = new Set((item.attachments ?? []).map(it => it.id))

			const adjustedAttachments = answers
				.filter(adjusted => !existingIds.has(adjusted.latestAnswer.id))
				.map(
					(adjusted, index) =>
						new SupplierEnrollmentNoticeAttachment({
							id: adjusted.latestAnswer.id,
							hasAttachment: true,
							created: adjusted.latestAnswer.created,
							type: SupplierEnrollmentNoticeAttachmentType.PROPOSAL,
							description: answers.length > 1 ? `Proposta Readequada ${index + 1}` : 'Proposta Readequada'
						})
				)

			if (adjustedAttachments.length > 0) {
				item.attachments = [...(item.attachments ?? []), ...adjustedAttachments]
			}
		})
	}

	/**
	 * spec 043: o documento juntado PARA uma solicitação de habilitação diz a qual prazo responde —
	 * o agente vê na sidebar "Habilitação: ITEM 1 — … (prazo até dd/MM)" abaixo do tipo. Busca
	 * assíncrona, só quando algum anexo carrega `qualificationId`.
	 */
	private annotateQualificationAttachments(item: SupplierEnrollmentNotice) {
		const sessionId = item?.noticeSession?.id
		if (!sessionId || !item?.id || !item?.demand?.isDispute) return

		const attachments = item.attachments ?? []
		if (!attachments.some(it => !!it.qualificationId)) return

		this.supplierEnrollmentNoticeQualificationService.listable(sessionId, item.id).subscribe(requests => {
			const byId = new Map((requests ?? []).map(request => [request.id, request]))

			attachments.forEach(attachment => {
				const request = attachment.qualificationId ? byId.get(attachment.qualificationId) : null
				if (request) attachment.qualificationLabel = `Habilitação: ${request.targetsLabel} (prazo até ${request.expiresAtLabel})`
			})
		})
	}

	modalDisputeAttachmentSupplierDownload(item: SupplierEnrollmentNotice, attachmentSidebar = false, download = true) {
		this.noticeAttachment = false
		this.supplierEnrollmentNotice = item
		this.attachmentSidebar = attachmentSidebar

		const proposalAttachment = new SupplierEnrollmentNoticeAttachment({
			id: item.id,
			hasAttachment: true,
			created: item.proposalAttachmentAt,
			type: SupplierEnrollmentNoticeAttachmentType.PROPOSAL_PRINCIPAL
		})

		item.attachments = item.proposalAttachment ? [proposalAttachment, ...item.attachments.filter(it => it.id !== item.id)] : item.attachments

		// Documentos GERADOS junto à documentação de habilitação: além da proposta inicial (acima),
		// as propostas readequadas respondidas entram na lista — o PDF de cada uma é o anexo da
		// resposta do participante. Busca assíncrona: a sidebar completa quando a lista chega.
		this.appendAdjustedProposalAttachments(item)
		this.annotateQualificationAttachments(item)

		this.supplierEnrollmentNoticeAttachment = item.attachments[0]

		if (!this.supplierEnrollmentNoticeAttachment) {
			this.toast.warn('Nenhum documento encontrado')
			return
		}

		item.attachments.forEach(it => {
			it.documentation = this.supplierEnrollmentNoticeAttachment.id === it.id
		})

		this.modal.open(this.modalAttachmentViewSupplier, { fullscreen: true })

		if (download) {
			this.supplierEnrollmentNotice.submitted = true
			this.attachmentService.downloadHandleBlob(this.supplierEnrollmentNoticeAttachment.id).subscribe(url => {
				this.supplierEnrollmentNotice.url = url
				this.supplierEnrollmentNotice.submitted = false
			})
		}
	}

	/**
	 * Inversão de fases (spec 047): documentação de habilitação que o participante enviou junto da proposta
	 * — a mesma régua do portal (documento `PRINCIPAL` com arquivo). Sem ela, o modal da proposta inicial
	 * deixa a falta em evidência, mas não bloqueia a decisão do agente (RF-16).
	 */
	protected hasQualificationDocumentation(item: SupplierEnrollmentNotice): boolean {
		return !!item?.attachments?.some(it => it.type === SupplierEnrollmentNoticeAttachmentType.PRINCIPAL && it.hasAttachment)
	}

	/**
	 * Documentação de habilitação que o agente confere ao julgar a habilitação na inversão (spec 047): só os
	 * `PRINCIPAL` com arquivo — a mesma régua de `hasQualificationDocumentation`, para a lista não contradizer
	 * o alerta de falta.
	 */
	protected qualificationInversionDocuments(item: SupplierEnrollmentNotice): SupplierEnrollmentNoticeAttachment[] {
		return (item?.attachments ?? []).filter(it => it.type === SupplierEnrollmentNoticeAttachmentType.PRINCIPAL && it.hasAttachment)
	}

	/**
	 * Demais documentos do participante (Complementar/Outros) — o agente também os confere, mas à parte: não
	 * contam como documentação de habilitação (spec 047).
	 */
	protected qualificationInversionOtherDocuments(item: SupplierEnrollmentNotice): SupplierEnrollmentNoticeAttachment[] {
		const types = [SupplierEnrollmentNoticeAttachmentType.COMPLEMENTARY, SupplierEnrollmentNoticeAttachmentType.OTHER]

		return (item?.attachments ?? []).filter(it => types.includes(it.type) && it.hasAttachment).sort((a, b) => a.type - b.type)
	}

	/**
	 * Abre o visualizador de documentos do participante (a sidebar com "Baixar Documentos") já no documento
	 * escolhido — sem ele, no comprovante da proposta, que o visualizador injeta como `PROPOSAL_PRINCIPAL`.
	 */
	protected viewQualificationInversionDocument(item: SupplierEnrollmentNotice, attachment?: SupplierEnrollmentNoticeAttachment) {
		this.modalDisputeAttachmentSupplierDownload(item, true, false)

		const target = attachment
			? item.attachments?.find(it => it.id === attachment.id)
			: item.attachments?.find(it => it.type === SupplierEnrollmentNoticeAttachmentType.PROPOSAL_PRINCIPAL)

		if (target) this.selectAttachmentDownload(target)
	}

	modalAttachmentSupplierProposal(attachment: SupplierEnrollmentNoticeAttachment) {
		this.modalAttachmentSupplierDownload(this.supplierEnrollmentNotice, attachment.type, true, false)
		this.selectAttachmentDownload(attachment)
	}

	onAttachmentSelected(event: Event) {
		const input = event.target as HTMLInputElement

		if (input.files && input.files.length > 0) {
			const file = input.files[0]

			if (file.size > 40 * 1024 * 1024) {
				this.toast.warn('O tamanho do arquivo não pode maior que 40MB')
				return
			}

			if (file.type !== 'application/pdf') {
				this.fileAttachmentControl.setValue(null)
				this.toast.warn('Formato invalido, informe um arquivo em PDF.')
				return
			}

			this.fileAttachmentControl.setValue(file)
		}
	}

	selectAttachmentDownload(attachment: SupplierEnrollmentNoticeAttachment) {
		this.supplierEnrollmentNotice.attachments.forEach(it => (it.documentation = false))
		attachment.documentation = true
		this.supplierEnrollmentNotice.submitted = true

		this.attachmentService.downloadHandleBlob(attachment.id).subscribe(url => {
			this.supplierEnrollmentNotice.url = url
			this.supplierEnrollmentNotice.submitted = false
		})
	}

	adjustedAttachmentDownload(item: SupplierEnrollmentNoticeAdjusted) {
		const attachmentId = item.latestAnswer?.id

		item.submitted = true

		this.attachmentService
			.downloadHandleBlob(attachmentId)
			.pipe(finalize(() => (item.submitted = false)))
			.subscribe(response => {
				this.attachmentUrl = response
				this.modal.open(this.modalAttachmentView, { fullscreen: true })
			})
	}

	feasibilityAttachmentDownload(item: SupplierEnrollmentNoticeFeasibility) {
		const attachmentId = item.latestAnswer?.id

		item.submitted = true

		this.attachmentService
			.downloadHandleBlob(attachmentId)
			.pipe(finalize(() => (item.submitted = false)))
			.subscribe(response => {
				this.attachmentUrl = response
				this.modal.open(this.modalAttachmentView, { fullscreen: true })
			})
	}

	enrollmentUndo(activity: LogActivity) {
		this.alertfy.confirm('Atenção', 'Deseja realmente realizar essa operação?', event => {
			if (event.confirmed) {
				activity.loading = true
				this.supplierEnrollmentNoticeService
					.undo(this.supplierEnrollmentNotice.id, activity.undo)
					.pipe(finalize(() => (activity.loading = false)))
					.subscribe(() => {
						this.modal.dismissAll()
						this.fetchSuppliersEnrollmentNotice()
						this.toast.success('Operação realizada com sucesso')
					})
			}
		})
	}

	editRepresentation(item: NoticeSessionRepresentation) {
		this.listableRepresentations = false
		this.noticeSessionRepresentation = item
		this.expiresAtControl.setValue(item.expiresAt)
		this.descriptionControl.setValue(item.message)
	}

	canProposalQualifyRejected(supplierEnrollmentNotice: SupplierEnrollmentNotice): boolean {
		return (
			(!supplierEnrollmentNotice.proposal ||
				supplierEnrollmentNotice.statusProposalSent ||
				supplierEnrollmentNotice.statusProposalAppropriate ||
				supplierEnrollmentNotice.statusProposalTrading ||
				(supplierEnrollmentNotice.statusCreated && supplierEnrollmentNotice.proposal)) &&
			!supplierEnrollmentNotice.statusProposalInapposite
		)
	}

	canProposalQualifyApprovedIsNotDispute(supplierEnrollmentNotice: SupplierEnrollmentNotice): boolean {
		return (
			supplierEnrollmentNotice.statusProposalSent ||
			supplierEnrollmentNotice.statusProposalInapposite ||
			!supplierEnrollmentNotice.proposal ||
			supplierEnrollmentNotice.statusProposalTrading ||
			(supplierEnrollmentNotice.statusCreated && supplierEnrollmentNotice.proposal)
		)
	}

	async documentAllDownload(item: SupplierEnrollmentNotice) {
		this.attachmentLoading = true

		const documents = item.demand.loose ? item.viewAttachments : item.viewDisputeAttachments
		const entries: ZipEntry[] = []

		for (const [i, document] of documents.entries()) {
			try {
				const file = await firstValueFrom(this.attachmentService.downloadHandleResponseBlob(document.id))
				const name = document.type === SupplierEnrollmentNoticeAttachmentType.PRINCIPAL ? `DOCUMENTO DE HABILITACAO ${i}` : `COMPLEMENTAR ${i}`

				entries.push({ name: `${name}.pdf`, blob: file })
			} catch (e) {
				console.error(e.message)
			}
		}

		const name = `${normalize(item?.supplier?.name, true)?.toUpperCase() ?? moment().unix()}_DOCUMENTOS.zip`
		await this.zipService.downloadZip(entries, name, 7)

		this.attachmentLoading = false
	}

	async confirmSupplierGenerateCertificate() {
		this.confirmSubmitted = true

		this.errorGenerateAnalytics = false
		this.errorGenerateCertificate = false

		this.submittedGenerateAnalytics = true

		const sources: Array<Promise<void>> = []
		const supplier = this.supplierEnrollmentNotice.supplier
		const formData = this.mapperDataDocumentGenerator(supplier)
		const approved = this.supplierEnrollmentNoticeStatus === SupplierEnrollmentNoticeStatus.APPROVED
		const message = this.descriptionControl.value ?? this.supplierEnrollmentNotice.lastMessageDocumentation

		this.submittedGenerateCertificate = approved
		this.supplierEnrollmentNotice.certificated = approved

		sources.push(this.generateReportAnalytics(approved, formData, message))
		sources.push(this.generateReportCertificate(formData))

		await Promise.allSettled(sources)

		setTimeout(() => {
			this.modal.dismissAll()
			this.confirmSubmitted = false
			this.fetchSuppliersEnrollmentNotice()
			this.descriptionControl.setValue(null)
		}, 1000)
	}

	async confirmSupplierJudging() {
		if (!this.supplierEnrollmentNoticeStatus || !this.supplierEnrollmentNotice) {
			this.modal.dismissAll()
			this.toast.warn('Favor atualizar a página e tentar novamente!')
			return
		}

		if (
			(this.supplierEnrollmentNoticeStatus === SupplierEnrollmentNoticeStatus.REJECTED ||
				this.supplierEnrollmentNoticeMessageType === SupplierEnrollmentNoticeMessageType.REOPENED) &&
			!this.descriptionControl.value
		) {
			this.toast.warn('Informe o motivo para continuar')
			return
		}

		const counterarguments = await firstValueFrom(this.fetchAllSuppliersEnrollmentCounterargumentPending(this.supplierEnrollmentNotice.id))

		if (counterarguments.length > 0) {
			this.modal.dismissAll()
			this.toast.warn('Existe uma pendência de recurso para deferir ou indeferir')

			setTimeout(() => {
				this.modalCounterargument(this.supplierEnrollmentNotice)
			}, 500)

			return
		}

		this.confirmSubmitted = true

		let messageId = null
		let hasAttachment = false

		if (this.fileAttachmentControl.value && (!this.fileUploadAttachmentDocument || this.fileUploadAttachmentDocument?.status === UploadStatus.ERROR)) {
			messageId = uuid()
			this.fileUploadAttachmentDocument = await this.uploadS3Service.uploadAttachment(messageId, this.fileAttachmentControl.value)

			if (this.fileUploadAttachmentDocument.status === UploadStatus.ERROR) {
				this.confirmSubmitted = false
				this.toast.warn('Tívemos um problema ao enviar o seu arquivo!')
				return
			}

			hasAttachment = true
		}

		const entity = new SupplierEnrollmentNoticeJudging({
			messageId,
			hasAttachment,
			id: this.supplierEnrollmentNotice.id,
			status: this.supplierEnrollmentNoticeStatus,
			type: this.supplierEnrollmentNoticeMessageType,
			message: this.descriptionControl.value
		})

		this.supplierEnrollmentNoticeService
			.judging(entity)
			.pipe(finalize(() => (this.confirmSubmitted = false)))
			.subscribe(() => {
				this.modal.dismissAll()
				this.fetchSuppliersEnrollmentNotice()
				this.fileUploadAttachmentDocument = null
				this.fileAttachmentControl.setValue(null)
				this.toast.success('Operação realizado com sucesso')
				this.supplierEnrollmentNotice.status = this.supplierEnrollmentNoticeStatus

				if (this.supplierEnrollmentNoticeStatus !== SupplierEnrollmentNoticeStatus.CREATED) {
					this.modalGenerateCertificate(this.supplierEnrollmentNotice, this.supplierEnrollmentNoticeStatus)
				}
			})
	}

	async reportFinal() {
		this.attachmentLoading = true

		try {
			const { id } = this.demand.noticeSession
			const formData = await this.mapperDataDocumentReportFinal()

			this.modal.open(this.modalAttachmentView, { fullscreen: true })

			const content = new ReportFinalPreQualificationAccreditationDocumentGenerator({ ...formData })
			const document = new DemandIntentDocumentReport({
				id,
				ordering: 3,
				metadata: { data: {} },
				date: moment().format('YYYY-MM-DD'),
				status: DemandIntentDocumentReportStatus.CREATED,
				type: DemandIntentDocumentReportType.REPORT_FINAL_PQ_ACCREDITATION
			})

			const documentGeneratorRequest = await this.documentGeneratorProvider.instanceSingle(document, content, true)
			const response = await firstValueFrom(this.documentGeneratorService.save(documentGeneratorRequest))

			if (response.status === 'error') {
				this.toast.error('Tívemos um problema ao tentar gerar o relatório, tente novamente!')
			}

			const request = new DocumentGeneratorRequest<BaseDocument>({
				sourceId: id,
				documentType: DocumentGeneratorType.REPORT_FINAL_PQ_ACCREDITATION
			})

			const convertResponse = await firstValueFrom(this.documentGeneratorService.convertPdf(request))

			if (convertResponse.status === 'error') {
				this.attachmentUrl = 'error'
				this.attachmentLoading = false
			} else {
				const documentBlob = await firstValueFrom(
					this.attachmentService.streamingById(convertResponse.id)
				)

				const file = new Blob([documentBlob], { type: 'application/pdf' })
				const reportBlobUrl = URL.createObjectURL(file)
				this.attachmentUrl = this.sanitize.bypassSecurityTrustResourceUrl(reportBlobUrl)
			}
		} catch (e) {
			console.error(e)
			this.attachmentUrl = 'error'
		} finally {
			this.attachmentLoading = false
		}
	}

	async attachmentNotice(event: any, sourceId: string, callback?: () => Promise<void>) {
		if (event.target && event.target.files.length > 0) {
			const file = event.target.files[0] as File

			if (file.type !== 'application/pdf') {
				this.toast.warn('Informe um documento no formato PDF')
				return
			}

			if (file.size > 29 * 1024 * 1024) {
				this.toast.warn('O tamanho do arquivo não pode maior que 30MB')
				return
			}

			this.submittedAttachmentLoading = true
			const response = await this.uploadS3Service.uploadAttachment(sourceId, file)

			if (response.status === UploadStatus.ERROR) {
				this.toast.error('Tívemos um problema ao enviar o arquivo')
				this.submittedAttachmentLoading = false
				return
			}

			await callback()

			this.submittedAttachmentLoading = false
		}
	}

	async confirmAllSupplierCanceled() {
		if (!this.descriptionControl.value) {
			this.toast.warn('Necessário informa a descrição')
			return
		}

		if (this.supplierEnrollmentNotices.length === 0) {
			this.toast.warn('Notificação já realizada!')
			return
		}

		const entities = this.supplierEnrollmentNotices.map(supplierEnrollmentNotice => {
			return new SupplierEnrollmentNoticeJudging({
				id: supplierEnrollmentNotice.id,
				message: this.descriptionControl.value,
				status: SupplierEnrollmentNoticeStatus.CANCELED,
				type: SupplierEnrollmentNoticeMessageType.DOCUMENTATION
			})
		})

		const requests = entities
			.filter(it => !it.success)
			.map(entity => {
				return this.supplierEnrollmentNoticeService.judging(entity).pipe(
					map(() => {
						entity.success = true
						return entity
					}),
					catchError(err => {
						entity.success = false
						return of(entity)
					})
				)
			})

		this.confirmSubmitted = true

		forkJoin(requests)
			.pipe(finalize(() => (this.confirmSubmitted = false)))
			.subscribe({
				next: response => {
					this.modal.dismissAll()
					this.fetchSuppliersEnrollmentNotice()

					if (response.every(it => it.success)) {
						this.descriptionControl.setValue(null)
						this.toast.success('Operação realizado com sucesso')
					}
				}
			})
	}

	async confirmAllPublishLooseSupplierOther() {
		// `submitted` marca quem já está aguardando a confirmação do PNCP — reenviar esses itens
		// enfileiraria a mesma publicação duas vezes.
		const entities = this.supplierEnrollmentNotices.filter(it => it.published === false && !it.submitted)

		if (entities.length === 0) {
			this.toast.warn('Nenhum fornecedor apto para incluir na publicação')
			return
		}

		this.submitted = true

		const chuckSupplierEnrollmentNotices = chunk(entities, 2)

		for (const chuck of chuckSupplierEnrollmentNotices) {
			await Promise.all(chuck.map(item => this.confirmPublishLooseSupplierOther(item)))
		}

		this.submitted = false
	}

	async confirmPublishLooseSupplierOther(item: SupplierEnrollmentNotice) {
		item.submitted = true
		item.publishError = null

		const response = await firstValueFrom(this.pncpOrganizationService.publishLooseSupplierOther(this.demand.id, item.id))

		if (response.status === 'error') {
			item.submitted = false
			item.publishError = response.message ?? 'Tívemos um problema ao processar a inclusão dos documentos na publicação, tente novamente!'
			return
		}

		// O backend só enfileira a publicação (202): quem confirma é o polling abaixo.
		this.waitingToStopPoolingSupplierPublish(item)
	}

	/**
	 * A publicação dos documentos do participante é processada de forma assíncrona pelo PNCP.
	 * `published` é o único sinal persistido — não existe campo de erro para esse recurso, então
	 * uma publicação que não confirma dentro do limite é reportada como não confirmada.
	 */
	private waitingToStopPoolingSupplierPublish(item: SupplierEnrollmentNotice) {
		this.supplierPublishPooling.set(item.id, item)

		if (this.supplierPublishPoolingSubscription) {
			return
		}

		this.supplierPublishPoolingSubscription = interval(10000)
			.pipe(
				takeUntil(this.destroy$),
				exhaustMap(total => {
					const pending = Array.from(this.supplierPublishPooling.values())

					if (pending.length === 0) {
						this.stopPoolingSupplierPublish()
						return EMPTY
					}

					if (total >= 30) {
						pending.forEach(pendingItem => {
							pendingItem.submitted = false
							pendingItem.publishError = 'Não recebemos a confirmação da publicação, atualize a página em alguns instantes para conferir a situação.'
						})

						this.stopPoolingSupplierPublish()
						return EMPTY
					}

					return forkJoin(pending.map(pendingItem => this.supplierEnrollmentNoticeService.detail(pendingItem.id).pipe(catchError(() => of(null)))))
				})
			)
			.subscribe(responses => {
				for (const response of responses) {
					const pendingItem = response?.published ? this.supplierPublishPooling.get(response.id) : null

					if (!pendingItem) {
						continue
					}

					pendingItem.published = true
					pendingItem.submitted = false
					this.supplierPublishPooling.delete(response.id)
				}

				if (this.supplierPublishPooling.size === 0) {
					this.stopPoolingSupplierPublish()
					this.toast.success('Documentos do participante publicados com sucesso.')
					this.fetchSuppliersEnrollmentNotice()
				}
			})
	}

	private stopPoolingSupplierPublish() {
		this.supplierPublishPoolingSubscription?.unsubscribe()
		this.supplierPublishPoolingSubscription = null
		this.supplierPublishPooling.clear()
	}

	async confirmCounterargumentJudging() {
		if (!this.supplierEnrollmentNoticeCounterargumentStatus || !this.supplierEnrollmentNoticeCounterargument) {
			this.modal.dismissAll()
			this.toast.warn('Favor atualizar a página e tentar novamente!')
			return
		}

		if (!this.fileAttachmentControl.value) {
			this.toast.warn('Favor informar um anexo para continuar')
			return
		}

		if (!this.descriptionControl.value) {
			this.toast.warn('Favor informar o motivo')
			return
		}

		this.confirmSubmitted = true
		this.changeDetectorRef.detectChanges()

		if (this.fileAttachmentControl.value && (!this.fileUploadAttachmentDocument || this.fileUploadAttachmentDocument?.status === UploadStatus.ERROR)) {
			this.fileUploadAttachmentDocument = await this.uploadS3Service.uploadAttachment(uuid(), this.fileAttachmentControl.value)

			if (this.fileUploadAttachmentDocument.status === UploadStatus.ERROR) {
				this.confirmSubmitted = false
				this.toast.warn('Tívemos um problema ao enviar o seu arquivo!')
				return
			}
		}

		const { id, supplierEnrollmentNotice } = this.supplierEnrollmentNoticeCounterargument
		const { id: attachmentId } = this.fileUploadAttachmentDocument

		const source =
			this.supplierEnrollmentNoticeCounterargumentStatus === SupplierEnrollmentNoticeCounterargumentStatus.GRATED
				? this.enrollmentCounterargumentService.granted(id, attachmentId, this.descriptionControl.value)
				: this.enrollmentCounterargumentService.rejected(id, attachmentId, this.descriptionControl.value)

		source.pipe(finalize(() => (this.confirmSubmitted = false))).subscribe(async () => {
			this.modalGratedCounterargumentRef?.dismiss()
			this.descriptionControl.setValue(null)
			this.fileAttachmentControl.setValue(null)
			this.toast.success('Operação realizado com sucesso')
			this.supplierEnrollmentNoticeCounterargument.status = this.supplierEnrollmentNoticeCounterargumentStatus
			this.counterarguments$ = this.enrollmentCounterargumentService.searchSupplier(supplierEnrollmentNotice.id)

			if (this.supplierEnrollmentCounterarguments && this.supplierEnrollmentCounterarguments.length > 0) {
				this.supplierEnrollmentCounterarguments = await firstValueFrom(this.fetchAllSuppliersEnrollmentCounterargumentPending())
			}
		})
	}

	protected canShowTradingButton(enrollment: SupplierEnrollmentNotice) {
		return (
			!enrollment.statusApproved &&
			!enrollment.statusRejected &&
			!enrollment.statusCreated &&
			!enrollment.statusProposalSent &&
			!enrollment.statusProposalQualificationApproved &&
			!enrollment.statusProposalQualificationRejected
		)
	}

	protected async afterAttachmentNoticeSupplierCertificatedReload() {
		this.attachmentSupplierToPDFDownload(this.supplierEnrollmentNotice, SupplierEnrollmentNoticeAttachmentType.CERTIFICATED, false)
	}

	private fetchAllFeasibilityAdjustedProposal(type: ModalProposalType, sessionId: string, enrollmentId: string) {
		if (type === 'feasibility') {
			this.feasibility$ = this.supplierEnrollmentNoticeFeasibilityService.listable(sessionId, enrollmentId)
		} else if (type === 'adjusted') {
			this.adjusted$ = this.supplierEnrollmentNoticeAdjustedService.listable(sessionId, enrollmentId)
		}
	}

	protected fetchAllSuppliersEnrollmentCounterargumentPending(enrollmentId?: string) {
		let page = 0
		const params = new HttpParams().set('page', page)
		const query = new SupplierEnrollmentNoticeCounterargumentSearch({
			noticeSessionId: this.demand.noticeSession.id,
			types: [SupplierEnrollmentNoticeCounterargumentType.APPEAL],
			statuses: [SupplierEnrollmentNoticeCounterargumentStatus.CREATED]
		})

		if (enrollmentId) {
			query.enrollmentId = enrollmentId
		}

		this.supplierEnrollmentCounterargumentLoading = true

		return this.enrollmentCounterargumentService.search(query, params).pipe(
			expand(response => {
				if (response.last) return EMPTY
				return this.enrollmentCounterargumentService.search(query, params.set('page', ++page))
			}),
			map(response => response.content),
			concatMap(content => from(content)),
			toArray(),
			finalize(() => (this.supplierEnrollmentCounterargumentLoading = false))
		)
	}

	protected fetchAllSuppliersEnrollmentNoticeReady() {
		let page = 0
		const params = new HttpParams().set('page', page)
		const query = new SupplierEnrollmentNoticeSearch({ attachment: true })

		this.supplierEnrollmentNoticesLoading = true

		return this.supplierEnrollmentNoticeService.searchSession(this.demand.noticeSession.id, params, query).pipe(
			expand(response => {
				if (response.last) return EMPTY
				return this.supplierEnrollmentNoticeService.searchSession(this.demand.noticeSession.id, params.set('page', ++page), query)
			}),
			map(response => response.content.filter(it => it.status === SupplierEnrollmentNoticeStatus.APPROVED).filter(it => it.published === false)),
			concatMap(content => from(content)),
			toArray(),
			finalize(() => (this.supplierEnrollmentNoticesLoading = false))
		)
	}

	protected fetchAllSuppliersEnrollmentNoticePending() {
		let page = 0
		const params = new HttpParams().set('page', page)
		const query = new SupplierEnrollmentNoticeSearch({
			payment: true,
			statuses: [SupplierEnrollmentNoticeStatus.CREATED]
		})

		this.supplierEnrollmentNoticesLoading = true

		return this.supplierEnrollmentNoticeService.searchSession(this.demand.noticeSession.id, params, query).pipe(
			expand(response => {
				if (response.last) return EMPTY
				return this.supplierEnrollmentNoticeService.searchSession(this.demand.noticeSession.id, params.set('page', ++page), query)
			}),
			map(response => response.content),
			concatMap(content => from(content)),
			toArray(),
			finalize(() => (this.supplierEnrollmentNoticesLoading = false))
		)
	}

	protected onSessionStatusChange(status: NoticeSessionStatus) {
		this.fetchSuppliersEnrollmentNotice()
		this.sessionStatusChange.emit(status)
	}

	protected fetchSuppliersEnrollmentNotice(page = 0, params?: HttpParams) {
		params = params ?? new HttpParams()
		params = params.set('page', page)

		this.supplierEnrollmentNoticeParams = params
		this.supplierEnrollmentNoticeService.size = 30
		this.supplierEnrollmentNotice$ = this.supplierEnrollmentNoticeService.searchSession(this.demand.noticeSession.id, params).pipe(
			tap(pageable => {
				this.indexParticipantOrder(pageable, page)
				this.sortParticipantsByEnrollmentOrder(pageable)
				this.currentParticipants = pageable.content
			})
		)
	}

	private async generateReportAnalytics(approved: boolean, formData: any, message: string) {
		const attachmentSelected = this.supplierEnrollmentNotice.attachments.find(it => it.type === SupplierEnrollmentNoticeAttachmentType.ANALYTICS)

		if (
			!attachmentSelected?.hasAttachment &&
			(this.supplierEnrollmentNoticeMessageType === SupplierEnrollmentNoticeMessageType.DOCUMENTATION ||
				this.supplierEnrollmentNoticeMessageType === SupplierEnrollmentNoticeMessageType.APPEAL ||
				this.forceGenerateDocuments)
		) {
			const dataForm = { ...formData, approved, message }
			const content = new ReportAnalyticsPreQualificationAccreditationDocumentGenerator(dataForm)

			const document = new DemandIntentDocumentReport({
				ordering: 2,
				metadata: { data: {} },
				id: attachmentSelected.id,
				date: moment().format('YYYY-MM-DD'),
				status: DemandIntentDocumentReportStatus.CREATED,
				type: DemandIntentDocumentReportType.REPORT_ANALYTICS_PQ_ACCREDITATION
			})

			try {
				await this.generateDocument(document, content, attachmentSelected.id)
			} catch (e) {
				console.error(e)
				this.errorGenerateAnalytics = true
			} finally {
				this.submittedGenerateAnalytics = false
			}
		}

		this.submittedGenerateAnalytics = false
	}

	private async generateReportCertificate(formData: any) {
		const documentType =
			this.demand.process.modality === ProcessModality.PRE_QUALIFICATION
				? DemandIntentDocumentReportType.NOTICE_CERTIFICATED_PRE_QUALIFICATION
				: DemandIntentDocumentReportType.NOTICE_CERTIFICATED_ACCREDITATION

		const attachmentSelected = this.supplierEnrollmentNotice.attachments.find(it => it.type === SupplierEnrollmentNoticeAttachmentType.CERTIFICATED)

		const document = new DemandIntentDocumentReport({
			ordering: 1,
			type: documentType,
			metadata: { data: {} },
			id: attachmentSelected.id,
			date: moment().format('YYYY-MM-DD'),
			status: DemandIntentDocumentReportStatus.CREATED
		})

		const content =
			documentType === DemandIntentDocumentReportType.NOTICE_CERTIFICATED_PRE_QUALIFICATION
				? new CertificatedPreQualificationDocumentGenerator(formData)
				: await this.getCertificatedAccreditationDocumentGenerator(formData)

		if (documentType === DemandIntentDocumentReportType.NOTICE_CERTIFICATED_ACCREDITATION && !content.responsibleName) {
			this.toast.error('O ordenador de despesas precisa ser cadastrado em responsabilidades!')
			return
		}

		if (this.supplierEnrollmentNotice.statusRejected) {
			return
		}

		try {
			await this.generateDocument(document, content, attachmentSelected.id)
			await firstValueFrom(this.supplierEnrollmentNoticeService.certificatedConfirm(this.supplierEnrollmentNotice.id))
		} catch (e) {
			console.error(e)
			this.errorGenerateCertificate = true
		} finally {
			this.submittedGenerateCertificate = false
		}
	}

	private mapperDataDocumentGenerator(supplier: Supplier) {
		const supplierResponsibleName = supplier.responsible?.name?.toUpperCase()
		const supplierResponsibleDocument = DocumentValidator.overshadowCpf(this.mask.transform(supplier.responsible?.document ?? '', 'CPF_CNPJ'))

		if (!supplierResponsibleDocument || !supplierResponsibleName) {
			this.confirmSubmitted = false
			this.toast.warn('Os dados do responsável não foram localizados, aguarde o participante finalizar o cadastro!')
			// TODO: incluir UPDATE com error e ISSUES
			throw new Error('Os dados do responsável não foram localizados, aguarde o participante finalizar o cadastro!')
		}

		return {
			...this.mapperBaseData,
			supplierName: supplier.name?.toUpperCase(),
			supplierAddress: this.label.formattedAddress(supplier.address),
			supplierDocument: this.mask.transform(supplier.document, 'CPF_CNPJ'),
			supplierResponsible: `${supplierResponsibleDocument} | ${supplierResponsibleName}`
		}
	}

	private async mapperDataDocumentReportFinal() {
		const events: Array<SessionEvent> = []
		const suppliers: Array<SessionSupplier> = []
		const {
			noticeSession,
			process: { modality }
		} = this.demand

		let page = 0
		const params = new HttpParams().set('size', 10).set('page', page)

		const sources = this.supplierEnrollmentNoticeService.searchSession(noticeSession.id, params).pipe(
			expand(response => {
				if (response.empty) return EMPTY
				return this.supplierEnrollmentNoticeService.searchSession(noticeSession.id, params.set('page', ++page))
			}),
			concatMap(response => response.content),
			toArray(),
			switchMap(enrollments => {
				const sources = enrollments.map(enrollment => {
					let counterargumentPage = 0

					return this.enrollmentCounterargumentService.searchSupplier(enrollment.id).pipe(
						expand(paginate => {
							if (paginate.empty) return EMPTY
							return this.enrollmentCounterargumentService.searchSupplier(
								enrollment.id,
								null,
								new HttpParams().set('page', ++counterargumentPage)
							)
						}),
						concatMap(response => response.content),
						toArray(),
						map(counterarguments => {
							enrollment.reportCounterarguments = counterarguments
							return enrollment
						})
					)
				})

				return forkJoin(sources)
			})
		)

		const results = await firstValueFrom(sources)
		const isPreQualification = modality === ProcessModality.PRE_QUALIFICATION

		for (const result of results) {
			const { name: supplierName, document } = result.supplier
			const supplierDocument = this.mask.transform(document, 'CPF_CNPJ')
			const supplierDateJudging = moment(result.lastDateJudging).format('DD/MM/YYYY HH:mm')
			let supplierDateDocument = moment(result.documentationDate).format('DD/MM/YYYY HH:mm')

			if (result.statusCanceled) {
				supplierDateDocument = 'Não enviado'
			}

			suppliers.push({ name: supplierName, document: supplierDocument, date: supplierDateDocument })

			let counterarguments = result.reportCounterarguments?.map(it => ({
				status: it.statusLabel,
				date: moment(it.created).format('DD/MM/YYYY HH:mm')
			}))

			if (counterarguments.length === 0) {
				counterarguments = [{ status: 'Não houve recurso', date: '' }]
			}

			let statusLabel = isPreQualification ? 'Pré-qualificado' : 'Credenciado'

			if (result.statusRejected) {
				statusLabel = `Não ${statusLabel.toLowerCase()}`
			}

			const messages = result.messages?.data as SupplierEnrollmentNoticeMessage[]
			const issues =
				messages
					?.filter(it => it.type === SupplierEnrollmentNoticeMessageType.DOCUMENTATION)
					?.filter(it => it.status === SupplierEnrollmentNoticeStatus.REJECTED)
					?.map(it => it.message)?.[0] ?? ''

			events.push({
				statusLabel,
				supplierName,
				supplierDocument,
				counterarguments,
				isPreQualification,
				supplierDateJudging,
				supplierDateDocument,
				approved: result.statusApproved,
				isAppeal: result.reportCounterarguments.length > 0,
				issues: `${issues ? 'uma vez que ' + issues : ''}`
			})
		}

		const listApproved = events
			?.filter(it => it.approved)
			?.map(it => ({
				name: it.supplierName,
				document: it.supplierDocument
			}))

		if (listApproved.length === 0) {
			this.toast.warn('Nenhum fornecedor aprovado')
			throw new Error('Nenhum fornecedor aprovado')
		}

		return {
			events,
			suppliers,
			listApproved,
			...this.mapperBaseData
		}
	}

	private get mapperBaseData() {
		const organization = this.accountService.account.organization
		const city = organization.address.city.toUpperCase()
		const entityName = organization.simpleName?.toUpperCase()
		const address = this.label.formattedAddress(organization.address)
		const entityDocument = this.mask.transform(organization.document, 'CPF_CNPJ')
		const state = this.label.fromState(organization.address.state)?.data?.acronym as string

		return {
			city,
			state,
			address,
			entity: entityName,
			document: entityDocument,
			entityEmail: organization.contacts.email,
			object: this.demand.object,
			unit: this.demand?.unit?.name ?? '',
			numProcess: this.demand.numProcess,
			date: moment().format('DD [de] MMMM [de] YYYY').toUpperCase(),
			responsibleName: this.demand.responsible.individual.name.toUpperCase(),
			numNotice: `${this.demand.noticeSession.externalCode}/${this.demand.exercise}`,
			modality: this.label.fromProcessModalities(this.demand.process.modality)?.label?.toUpperCase()
		}
	}

	private async getCertificatedAccreditationDocumentGenerator(data: any) {
		const entity = new CertificatedAccreditationDocumentGenerator({ ...data, agentName: data.responsibleName })

		entity.responsibleName = await this.getResponsibleName()
		entity.contractEstimates = await this.getContractEstimates()

		const subTotal = entity.contractEstimates.map(it => it.totalNumber).reduce((acc, prv) => acc + prv, 0)

		entity.subTotal = ChartUtil.toCurrency(subTotal, 2)

		return entity
	}

	private async generateDocument(document: DemandIntentDocumentReport, content: any, attachmentId: string) {
		const documentGeneratorRequest = await this.documentGeneratorProvider.instanceSingle(document, content, true)
		const response = await firstValueFrom(this.documentGeneratorService.save(documentGeneratorRequest))

		if (response.status === 'error') {
			this.confirmSubmitted = false
			this.toast.error('Tívemos um problema ao tentar gerar o documento, tente novamente!')
			throw new Error('Tívemos um problema ao tentar gerar o documento, tente novamente!')
		} else {
			await firstValueFrom(this.supplierEnrollmentNoticeService.attachmentsConfirmed(attachmentId))
		}
	}

	private attachmentDownloadResolver(item: any, resourceId: string) {
		if (!item.hasAttachment) {
			this.toast.info('Não contem anexo')
			return
		}

		item.submitted = true

		this.attachmentService
			.downloadHandleBlob(resourceId)
			.pipe(finalize(() => (item.submitted = false)))
			.subscribe(response => {
				this.attachmentUrl = response
				this.modal.open(this.modalAttachmentView, { fullscreen: true })
			})
	}

	private filterMessages(data: SupplierEnrollmentNoticeMessage[]) {
		return data?.filter(it => it?.message !== undefined && it?.message !== '') ?? []
	}

	private loadItemsWithProposals(item: SupplierEnrollmentNotice, setupTradingSelection = false) {
		this.loadingProposal = true
		this.hasAnyProposalInBids = false

		this.items$ = this.demandIntentDocumentService.itensProcess(item.demand.externalCode).pipe(
			switchMap(items =>
				this.supplierEnrollmentNoticeProposalService.latest(item.noticeSession.id, item.id).pipe(map(proposals => ({ proposals, items }) as ResultProposal))
			),
			map((result: ResultProposal) => {
				const items = result.items.map(it => {
					const proposal = result.proposals.find(proposal => proposal.item.id === it.id)
					it.instance(proposal)
					return it
				})
				this.hasAnyProposalInBids = items.some(it => (it?.proposals?.length ?? 0) > 0)

				if (setupTradingSelection) {
					this.setupTradingSelection(items)
				}

				return items
			}),
			finalize(() => (this.loadingProposal = false))
		)

		if (setupTradingSelection) {
			firstValueFrom(this.items$).catch(() => {
				this.clearTradingSelection()
				this.loadingProposal = false
			})
		}
	}

	toggleTradingItem(itemId: string, checked: boolean) {
		if (this.isBidTypeBatch) return

		if (!itemId) return

		if (checked) {
			this.tradingSelectedItemIds.add(itemId)
		} else {
			if (this.tradingSelectedItemIds.size <= 1) {
				this.toast.warn('É necessário manter ao menos 1 item selecionado.')
				return
			}

			this.tradingSelectedItemIds.delete(itemId)
		}
	}

	toggleAllTradingItems(checked: boolean) {
		if (this.isBidTypeBatch) return

		if (!checked) {
			this.toast.warn('É necessário manter ao menos 1 item selecionado.')
			return
		}

		this.tradingSelectedItemIds.clear()

		if (checked) {
			for (const item of this.tradingItemsWithLatestProposal) {
				const itemId = item?.id
				if (itemId) {
					this.tradingSelectedItemIds.add(itemId)
				}
			}
		}
	}

	isTradingItemSelected(itemId: string): boolean {
		return !!itemId && this.tradingSelectedItemIds.has(itemId)
	}

	get isTradingAllSelected(): boolean {
		if (this.isBidTypeBatch) return false

		const total = this.tradingItemsWithLatestProposal.length
		return total > 0 && this.tradingSelectedItemIds.size === total
	}

	get tradingSelectedProposals() {
		return Array.from(this.tradingSelectedItemIds).map(id => ({ item: { id } }))
	}

	get hasTradingSelectedItems() {
		return this.tradingSelectedItemIds.size > 0
	}

	get tradingBatchGroups(): BatchItemsGroup[] {
		return this.groupItemsByBatch(this.tradingItemsWithLatestProposal)
	}

	get isSingleTradingBatch(): boolean {
		return this.tradingBatchGroups.length === 1
	}

	toggleTradingBatch(batchKey: string, checked: boolean) {
		if (!this.isBidTypeBatch || !batchKey) return

		if (!checked && this.isSingleTradingBatch) {
			this.toast.warn('É necessário manter ao menos 1 lote selecionado.')
			return
		}

		this.tradingSelectedItemIds.clear()

		if (!checked) {
			return
		}

		for (const item of this.tradingItemsWithLatestProposal) {
			if ((item.batchExternalCode || 'NO_BATCH') === batchKey && item?.id) {
				this.tradingSelectedItemIds.add(item.id)
			}
		}
	}

	isTradingBatchSelected(batchKey: string): boolean {
		if (!batchKey) return false
		const batchItems = this.tradingItemsWithLatestProposal.filter(it => (it.batchExternalCode || 'NO_BATCH') === batchKey)
		return batchItems.length > 0 && batchItems.every(it => !!it.id && this.tradingSelectedItemIds.has(it.id))
	}

	getTradingBatchProposalAmount(batch: BatchItemsGroup): number {
		return (batch?.items ?? []).reduce((acc, item) => acc + Number(item?.latestProposal?.amount ?? 0), 0)
	}

	/** Da proposta inicial, só o envio que vale: os anteriores o participante trocou antes da abertura (26/10/2026). */
	getClassificationProposals(item: DemandIntentDocumentProcessItem): SupplierEnrollmentNoticeProposalBidData[] {
		return proposalBidsWithCurrentInitial(item?.proposals ?? []).sort((a, b) => {
			if (!!a?.qualified !== !!b?.qualified) {
				return a?.qualified ? -1 : 1
			}

			const dateA = a?.qualifiedAt ?? a?.created
			const dateB = b?.qualifiedAt ?? b?.created

			return moment(dateB).unix() - moment(dateA).unix()
		})
	}

	groupItemsByBatch(items: DemandIntentDocumentProcessItem[]): BatchItemsGroup[] {
		const groups = new Map<string, BatchItemsGroup>()

		for (const item of items ?? []) {
			const batchKey = item.batchExternalCode || 'NO_BATCH'

			if (!groups.has(batchKey)) {
				groups.set(batchKey, {
					batchKey,
					batchExternalCode: item.batchExternalCode,
					batchDescription: item.batchDescription,
					items: []
				})
			}

			groups.get(batchKey).items.push(item)
		}

		return Array.from(groups.values())
	}

	get isBidTypeBatch() {
		return this.demand?.process?.bidType === ProcessBidType.BATCH
	}

	private setupTradingSelection(items: DemandIntentDocumentProcessItem[]) {
		this.tradingAllItemsWithLatestProposal = items.filter(it => !!it.latestProposal && !!it?.id)
		this.applyTradingSelectionFromTradeProposals()
	}

	private clearTradingSelection() {
		this.tradingAllItemsWithLatestProposal = []
		this.tradingItemsWithLatestProposal = []
		this.tradingSelectedItemIds.clear()
	}

	private applyTradingSelectionFromTradeProposals() {
		const proposalItemIds = new Set((this.trading?.proposals ?? []).map(it => it?.item?.id).filter(Boolean))

		if (!this.isBidTypeBatch) {
			this.tradingItemsWithLatestProposal =
				proposalItemIds.size > 0
					? this.tradingAllItemsWithLatestProposal.filter(it => proposalItemIds.has(it.id))
					: [...this.tradingAllItemsWithLatestProposal]

			this.tradingSelectedItemIds.clear()

			for (const item of this.tradingItemsWithLatestProposal) {
				this.tradingSelectedItemIds.add(item.id)
			}
			return
		}

		if (proposalItemIds.size > 0) {
			const selectedBatchKeys = new Set(
				this.tradingAllItemsWithLatestProposal.filter(it => proposalItemIds.has(it.id)).map(it => it.batchExternalCode || 'NO_BATCH')
			)

			this.tradingItemsWithLatestProposal = this.tradingAllItemsWithLatestProposal.filter(it => selectedBatchKeys.has(it.batchExternalCode || 'NO_BATCH'))
		} else {
			this.tradingItemsWithLatestProposal = [...this.tradingAllItemsWithLatestProposal]
		}

		this.tradingSelectedItemIds.clear()

		const batchGroups = this.tradingBatchGroups
		if (batchGroups.length === 0) {
			return
		}

		if (proposalItemIds.size > 0) {
			const selectedBatch = this.tradingAllItemsWithLatestProposal.find(it => proposalItemIds.has(it.id))?.batchExternalCode || 'NO_BATCH'
			this.toggleTradingBatch(selectedBatch, true)
			return
		}

		if (batchGroups.length === 1) {
			this.toggleTradingBatch(batchGroups[0].batchKey, true)
		}
	}

	private loadTrades(item: SupplierEnrollmentNotice, form = false) {
		this.loadingTrading = true
		this.supplierEnrollmentNoticeTradingService
			.latest(item.noticeSession.id, item.id)
			.pipe(finalize(() => (this.loadingTrading = false)))
			.subscribe(trading => {
				this.trading = trading ?? null
				this.applyTradingSelectionFromTradeProposals()
			})
	}

	private async getContractEstimates() {
		if (!this.contractEstimates || this.contractEstimates.length === 0) {
			const source = this.demandIntentDocumentItemService.allItems(this.demand.id).pipe(
				map(response =>
					response.map((item, i) => {
						return {
							item: i + 1,
							unit: item.productUnit,
							description: item.productName,
							totalNumber: item.amount * item.total,
							amount: ChartUtil.toNumber(item.total),
							value: ChartUtil.toCurrency(item.amount, 2),
							total: ChartUtil.toCurrency(item.amount * item.total, 2)
						} as ContractEstimateRow
					})
				)
			)

			this.contractEstimates = await firstValueFrom(source)
		}

		return this.contractEstimates
	}

	private async getResponsibleName() {
		if (!this.attachmentResponsibleExpenseManagement) {
			this.attachmentResponsibleExpenseManagement = await this.documentGeneratorProvider.fetchResponsible(
				RESPONSIBILITY_EXPENSE_MANAGER_ID,
				this.demand.unit.id
			)
		}

		return this.attachmentResponsibleExpenseManagement?.responsibleName
	}

	get messages() {
		return this.filterMessages(this.supplierEnrollmentNotice?.messages?.data)?.sort((a, b) => moment(b.created).unix() - moment(a.created).unix())
	}

	get fileAttachmentControl(): FormControl {
		return this.formAttachment.get('file') as FormControl
	}

	get fileAttachmentControlInvalid(): boolean {
		return this.fileAttachmentControl.invalid && this.fileAttachmentControl.touched
	}

	get supplierEnrollmentNoticeLabel(): string {
		return this.supplierEnrollmentNoticeStatus === SupplierEnrollmentNoticeStatus.REJECTED
			? 'Rejeitado'
			: this.supplierEnrollmentNoticeStatus === SupplierEnrollmentNoticeStatus.APPROVED
				? 'Qualificado'
				: 'Desfazer julgamento'
	}

	get supplierEnrollmentNoticeStatusLabel(): string {
		return this.supplierEnrollmentNoticeStatus === SupplierEnrollmentNoticeStatus.REJECTED
			? 'rejeição'
			: this.supplierEnrollmentNoticeStatus === SupplierEnrollmentNoticeStatus.APPROVED
				? 'aprovação (opcional)'
				: 'desfazer julgamento'
	}

	get supplierEnrollmentNoticeStatusCounterargumentLabel(): string {
		return this.supplierEnrollmentNoticeCounterargumentStatus === SupplierEnrollmentNoticeCounterargumentStatus.REJECTED
			? 'Indeferido'
			: this.supplierEnrollmentNoticeCounterargumentStatus === SupplierEnrollmentNoticeCounterargumentStatus.GRATED
				? 'Deferido'
				: ''
	}

	protected bidPhasesAllFinished = false
	private participantNicknameByUserId = new Map<string, string>()
	private participantOrderByEnrollmentId = new Map<string, number>()

	/**
	 * Sigilo de identidade (regra de 2026-09-08): nas modalidades com disputa (Pregão, Concorrência
	 * e Dispensa com disputa) os nomes dos participantes não aparecem — nem na lista, nem nos
	 * títulos derivados dela — até TODAS as fases de lances terminarem. Até lá a lista mostra apenas
	 * o `nickname` já definido no chat da sessão; documento, endereço e contato ficam ocultos, já
	 * que identificam tanto quanto o nome.
	 */
	get participantIdentityHidden(): boolean {
		// Sessão fechada revela sempre (inclusive o encerramento forçado, que fecha com fase aberta).
		if (this.demand?.noticeSession?.statusClosed || this.demand?.noticeSession?.forcedClosure) return false

		return !!this.demand?.isDisputeWithBids && !this.bidPhasesAllFinished
	}

	/**
	 * Rótulo do participante com a identidade sigilosa ativa. O apelido do chat, quando existe,
	 * continua valendo; sem ele o rótulo é NUMERADO pela ordem de inscrição ("Participante 1",
	 * "Participante 2") — antes todos apareciam como o mesmo "Participante" genérico e a lista
	 * ficava indistinguível (ajuste de 2026-09-21).
	 */
	protected participantDisplayName(item: SupplierEnrollmentNotice): string {
		const name = item?.supplier?.name

		if (!this.participantIdentityHidden) {
			return name || '-'
		}

		const userId = (item?.supplier as any)?.['userId']
		const nickname = userId ? this.participantNicknameByUserId.get(userId) : null

		if (nickname) return nickname

		const order = item?.id ? this.participantOrderByEnrollmentId.get(item.id) : null

		return order ? `Participante ${order}` : 'Participante'
	}

	/**
	 * Exibição do MENOR para o MAIOR ("Participante 1", "Participante 2"...). A consulta vem
	 * `createdAt,desc` e inverter isso no serviço não é opção: `sortColumn`/`sortDirection` são do
	 * singleton `SupplierEnrollmentNoticeService`, compartilhado com a tela do fornecedor — a
	 * ordenação de EXIBIÇÃO é feita aqui, sobre a página recebida, pelo mesmo número do rótulo.
	 *
	 * Escopo: sessões com disputa, onde a numeração existe; nas demais modalidades a lista segue na
	 * ordem que sempre teve (mais recentes primeiro).
	 */
	private sortParticipantsByEnrollmentOrder(pageable: Paginate<SupplierEnrollmentNotice>) {
		if (!this.demand?.isDisputeWithBids) return
		if (!this.participantOrderByEnrollmentId.size) return

		const orderOf = (item: SupplierEnrollmentNotice) => this.participantOrderByEnrollmentId.get(item?.id) ?? Number.MAX_SAFE_INTEGER

		pageable.content = [...(pageable.content ?? [])].sort((a, b) => orderOf(a) - orderOf(b))
	}

	/**
	 * Numeração pela ORDEM DE INSCRIÇÃO (1 = primeiro a se inscrever). A listagem vem paginada e
	 * ordenada por `createdAt` DESC (padrão do ManagementApiBaseService), então a posição real é
	 * `totalElements - deslocamento` — assim o número não reinicia a cada página nem inverte.
	 * Reconstruído a cada busca: a página corrente é sempre a que está em tela (inclusive nos
	 * títulos de modal, que derivam do item selecionado na lista).
	 */
	private indexParticipantOrder(pageable: Paginate<SupplierEnrollmentNotice>, requestedPage: number) {
		this.participantOrderByEnrollmentId.clear()

		const total = Number(pageable?.totalElements ?? 0)
		const size = Number(pageable?.size ?? 0) || this.supplierEnrollmentNoticeService.size || 30
		// A página do SERVIDOR, não a pedida: se ele limitar/ajustar a página, o deslocamento
		// calculado aqui divergiria da lista renderizada (o template usa `paginate.page`).
		const page = Number.isFinite(Number(pageable?.page)) ? Number(pageable.page) : requestedPage

		;(pageable?.content ?? []).forEach((item, index) => {
			if (!item?.id) return

			const order = total - (page * size + index)

			if (order > 0) this.participantOrderByEnrollmentId.set(item.id, order)
		})
	}

	private fetchParticipantNicknames() {
		const sessionId = this.demand?.noticeSession?.id
		const tenantId = this.demand?.noticeSession?.tenantId
		if (!sessionId || !tenantId || !this.demand?.isDisputeWithBids) return

		const params = new HttpParams().set('noticeSessionId', sessionId).set('size', '1').set('sort', 'updatedAt,desc')

		this.chatRoomService
			.list(tenantId, params)
			.pipe(takeUntil(this.destroy$))
			.subscribe(response => {
				this.participantNicknameByUserId.clear()

				for (const participant of response?.content?.[0]?.participants ?? []) {
					if (participant?.role !== ChatParticipantRole.SUPPLIER) continue
					const userId = participant?.member?.userId
					const nickname = participant?.member?.nickName || participant?.member?.name
					if (userId && nickname) this.participantNicknameByUserId.set(userId, nickname)
				}
			})
	}

	get isTradingOrCompetitionModality(): boolean {
		return [ProcessModality.ELECTRONIC_TRADING, ProcessModality.ELECTRONIC_COMPETITION].includes(this.demand?.process?.modality)
	}

	/**
	 * Ação "Proposta Readequada" do menu do participante (2026-09-08): é ato da sessão em andamento
	 * (some com a sessão fechada, qualquer modalidade) e, nas modalidades com disputa, só existe
	 * depois de TODAS as fases de lances terminarem. O cabimento continua o original: negociação em
	 * curso ou já fechada.
	 */
	protected canShowAdjustedProposalAction(item: SupplierEnrollmentNotice): boolean {
		if (!this.demand?.noticeSession?.statusOpened) return false
		if (this.demand?.isDisputeWithBids && !this.bidPhasesAllFinished) return false

		return item.statusProposalTrading || item.tradingClosed
	}

	/** Rótulo do menu/modal de propostas do participante (ver fetchBidPhasesFinishedState). */
	get proposalsMenuLabel(): string {
		return this.isTradingOrCompetitionModality && !this.bidPhasesAllFinished ? 'Proposta Inicial' : 'Propostas'
	}

	get hasOpenedBidPhaseInDispute(): boolean {
		const modality = this.demand?.process?.modality
		const isWithDispute = [
			ProcessModality.ELECTRONIC_DISPENSATION_WITH_DISPUTE,
			ProcessModality.ELECTRONIC_TRADING,
			ProcessModality.ELECTRONIC_COMPETITION
		].includes(modality)

		return !!isWithDispute && !!this.demand?.noticeSession?.bidPhase
	}
}

export class LogActivity {
	date: string
	title: string
	status: string
	ordering: number
	loading: boolean
	enabled: boolean
	description: string
	undo: SupplierEnrollmentNoticeUndoStatus

	action: 'DONE' | 'UNKNOWN' | 'DANGER' | 'WARN'
	step: 'PROPOSAL_AVAILABLE' | 'TRADES' | 'FEASIBILITY' | 'ADJUSTED' | 'PROPOSAL_DEADLINE_QUALIFICATION' | 'DOCUMENTATION' | 'PROPOSAL_QUALIFICATION'

	constructor(source?: Partial<LogActivity>) {
		if (source) {
			this.step = source.step
			this.undo = source.undo
			this.title = source.title
			this.action = source.action
			this.status = source.status
			this.ordering = source.ordering
			this.description = source.description

			this.loading = true
			this.enabled = false
			this.action = 'UNKNOWN'
		}
	}

	/**
	 * Passos da linha do tempo. `undo` marca os que o agente pode desfazer pelo modal.
	 *
	 * Com disputa, a adequação da proposta é decidida na Classificação — pela apuração dos lances e
	 * pelos atos do agente sobre ela — e não volta por aqui: desfazê-la deixaria a disputa apontando
	 * para uma proposta que oficialmente deixou de ser aceita (24/09/2026).
	 *
	 * Habilitação e declaração de vencedor são atos POR PROPOSTA arrematada, na Classificação (spec
	 * 043): aqui ficam só informativos, e o desfazer é por proposta, no modal de habilitação. O
	 * servidor recusa os dois pedidos antigos de qualquer forma.
	 */
	static getAllActives(options: { disputeWithBids?: boolean } = {}): Array<LogActivity> {
		return [
			new LogActivity({
				ordering: 1,
				title: 'Adequação',
				step: 'PROPOSAL_AVAILABLE',
				undo: options.disputeWithBids ? undefined : SupplierEnrollmentNoticeUndoStatus.PROPOSAL_AVAILABLE,
				description: 'Define se a proposta do fornecedor está adequada com o processo'
			}),
			new LogActivity({
				ordering: 2,
				title: 'Negociação',
				step: 'TRADES',
				description: 'Quando realizado, retorna ao participante para informar os possíveis descontos (lances finais)'
			}),
			new LogActivity({
				ordering: 3,
				title: 'Exequibilidade',
				step: 'FEASIBILITY',
				description: 'Quando realizado, é solicita ao participante um prazo para inclusão da comprovação necessária'
			}),
			new LogActivity({
				ordering: 4,
				title: 'Proposta Readequada',
				step: 'ADJUSTED',
				description: 'Quando realizado, é solicita ao participante um prazo para incluir a comprovação da proposta'
			}),
			new LogActivity({
				ordering: 5,
				title: 'Habilitação',
				step: 'PROPOSAL_DEADLINE_QUALIFICATION',
				description: 'Prazo concedido ao participante para juntar a documentação da proposta arrematada (por proposta, na Classificação)'
			}),
			new LogActivity({
				ordering: 6,
				title: 'Declaração de Vencedor',
				step: 'PROPOSAL_QUALIFICATION',
				description: 'Proposta habilitada — vencedora do item/lote (julgada por proposta, na Classificação)'
			})
		]
	}

	get content(): string {
		let date = ''
		let status = ''

		if (this.date) {
			date = `<span class="text-muted"><i class="fa-regular fa-calendar"></i> ${moment(this.date).format('DD/MM/YYYY HH:mm')}</span><br>`
		}

		if (this.status) {
			status = `<small class="badge badge-sm rounded-pill fw-600 ${this.labelColor}">${this.status}</small>`
		}

		return `
			<p class="text-muted fw-700 text-indigo mb-0">${this.title}</p>
			<small class="text-muted lh-sm d-inline-block w-100">${this.description}</small>			
			${date}
			${status}
		`
	}

	get labelColor(): string {
		switch (this.action) {
			case 'DONE':
				return 'bg-green'
			case 'UNKNOWN':
				return 'bg-dark'
			case 'WARN':
				return 'bg-info'
			case 'DANGER':
				return 'bg-orange'
			default:
				return 'bg-dark'
		}
	}

	actionDetected(enrollment: SupplierEnrollmentNotice): void {
		if (enrollment.statusCreated) {
			this.loading = false
			return
		}

		if (this.step === 'PROPOSAL_AVAILABLE') {
			if (enrollment.statusProposalSent) {
				this.action = 'WARN'
				this.status = 'Proposta Enviada'
				this.date = enrollment.proposalAppropriateAt
			} else if (enrollment.proposalAppropriateAt || enrollment.statusProposalAppropriate) {
				this.enabled = true
				this.action = 'DONE'
				this.date = enrollment.proposalAppropriateAt
				this.status = 'Proposta Aceita'
			} else if (enrollment.statusProposalInapposite) {
				this.enabled = true
				this.action = 'DANGER'
				this.status = 'Proposta Rejeitada'
			} else {
				if (enrollment.approvedAt) {
					this.action = 'DONE'
				}
			}

			this.loading = false
		}

		if (this.step === 'PROPOSAL_DEADLINE_QUALIFICATION') {
			if (enrollment.proposalApprovedAt && enrollment.statusProposalQualificationApproved) {
				this.enabled = true
				this.action = 'DONE'
				this.status = 'Proposta Habilitada'
				this.date = enrollment.proposalApprovedAt
			} else if (enrollment.statusProposalQualificationRejected) {
				this.enabled = true
				this.action = 'DANGER'
				this.status = 'Proposta não Habilitada'
			} else {
				if (enrollment.statusApproved || enrollment.statusRejected) {
					this.enabled = true
					this.action = 'DONE'
				}
			}

			this.loading = false
		}

		if (this.step === 'PROPOSAL_QUALIFICATION') {
			if (enrollment.approvedAt && enrollment.statusApproved) {
				this.enabled = true
				this.action = 'DONE'
				this.status = 'Vencedor'
				this.date = enrollment.approvedAt
			} else if (enrollment.statusRejected) {
				this.enabled = true
				this.action = 'DANGER'
			}

			this.loading = false
		}
	}
}
